var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 412.838,
    height: 235.781,
    viewBox: "0 0 412.838 235.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "online",
    transform: "translate(-22.733 -45.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(26.418 45.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1727",
    "data-name": "Group 1727",
    transform: "translate(321.732 92.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1718",
    "data-name": "Group 1718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1717",
    "data-name": "Group 1717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1716",
    "data-name": "Group 1716"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M582.8,202.631h83.393L652.6,212.477v19.372a4.036,4.036,0,0,1-4.027,4.045H582.8a4.036,4.036,0,0,1-4.027-4.045V206.676A4.036,4.036,0,0,1,582.8,202.631Z",
    transform: "translate(-578.768 -202.631)",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1722",
    "data-name": "Group 1722",
    transform: "translate(7.506 13.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1721",
    "data-name": "Group 1721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1720",
    "data-name": "Group 1720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1719",
    "data-name": "Group 1719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M591.593,225.818c0,.081,12.577.146,28.089.146s28.092-.065,28.092-.146-12.575-.146-28.092-.146S591.593,225.737,591.593,225.818Z",
    transform: "translate(-591.593 -225.672)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1726",
    "data-name": "Group 1726",
    transform: "translate(7.506 20.982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1725",
    "data-name": "Group 1725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1724",
    "data-name": "Group 1724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1723",
    "data-name": "Group 1723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M591.593,238.47c0,.081,12.577.146,28.089.146s28.092-.066,28.092-.146-12.575-.146-28.092-.146S591.593,238.389,591.593,238.47Z",
    transform: "translate(-591.593 -238.324)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1751",
    "data-name": "Group 1751",
    transform: "translate(162.606 7.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1750",
    "data-name": "Group 1750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1749",
    "data-name": "Group 1749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1748",
    "data-name": "Group 1748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1729",
    "data-name": "Group 1729",
    transform: "translate(32.597 13.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1728",
    "data-name": "Group 1728"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 3.903,
    height: 13.13,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1731",
    "data-name": "Group 1731",
    transform: "translate(0 11.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1730",
    "data-name": "Group 1730"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 3.903,
    height: 15.033,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1733",
    "data-name": "Group 1733",
    transform: "translate(8.149 8.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1732",
    "data-name": "Group 1732"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 3.903,
    height: 18.166,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1735",
    "data-name": "Group 1735",
    transform: "translate(16.298 9.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1734",
    "data-name": "Group 1734"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 3.903,
    height: 17.169,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1737",
    "data-name": "Group 1737",
    transform: "translate(24.448 3.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1736",
    "data-name": "Group 1736"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 3.903,
    height: 22.978,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1739",
    "data-name": "Group 1739",
    transform: "translate(40.746 3.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1738",
    "data-name": "Group 1738"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 3.903,
    height: 22.866,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1741",
    "data-name": "Group 1741",
    transform: "translate(48.895 11.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1740",
    "data-name": "Group 1740"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 3.902,
    height: 15.356,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1743",
    "data-name": "Group 1743",
    transform: "translate(57.044 4.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1742",
    "data-name": "Group 1742"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 3.903,
    height: 21.859,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1745",
    "data-name": "Group 1745",
    transform: "translate(65.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1744",
    "data-name": "Group 1744"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 3.903,
    height: 26.783,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1747",
    "data-name": "Group 1747",
    transform: "translate(73.343 4.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1746",
    "data-name": "Group 1746"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 3.903,
    height: 21.971,
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1758",
    "data-name": "Group 1758",
    transform: "translate(310.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1754",
    "data-name": "Group 1754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1753",
    "data-name": "Group 1753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1752",
    "data-name": "Group 1752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M591.424,78.3,623.7,73.351a32.652,32.652,0,1,1-37.205-27.463,32.5,32.5,0,0,1,8.516-.178Z",
    transform: "translate(-558.778 -45.512)",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1757",
    "data-name": "Group 1757",
    transform: "translate(39.199 0.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1756",
    "data-name": "Group 1756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1755",
    "data-name": "Group 1755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M629.675,46.025l-3.919,25.129,24.557-4.632S646.7,52.439,629.675,46.025Z",
    transform: "translate(-625.756 -46.025)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1765",
    "data-name": "Group 1765",
    transform: "translate(13.137 76.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1760",
    "data-name": "Group 1760",
    transform: "translate(0 1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1759",
    "data-name": "Group 1759"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M51.479,193.492a16,16,0,1,1,16.258,15.886A16.1,16.1,0,0,1,51.479,193.492Zm23.651-.383a7.652,7.652,0,1,0-7.527,7.843A7.693,7.693,0,0,0,75.129,193.109Z",
    transform: "translate(-51.476 -177.085)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1762",
    "data-name": "Group 1762",
    transform: "translate(0 1.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1761",
    "data-name": "Group 1761"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M51.479,193.494a16.1,16.1,0,0,1,15.744-16.4l.134,8.425a7.721,7.721,0,0,0,.246,15.439l.134,8.425A16.087,16.087,0,0,1,51.479,193.494Z",
    transform: "translate(-51.476 -177.089)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1764",
    "data-name": "Group 1764",
    transform: "translate(14.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1763",
    "data-name": "Group 1763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M75.926,174.882a18.322,18.322,0,0,1,18.721,18.294l-9.769.159c-.079-4.98-3.851-8.116-8.787-8.035Z",
    transform: "translate(-75.926 -174.88)",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1898",
    "data-name": "Group 1898",
    transform: "translate(0 148.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1879",
    "data-name": "Group 1879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1808",
    "data-name": "Group 1808",
    transform: "translate(5.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1804",
    "data-name": "Group 1804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1768",
    "data-name": "Group 1768",
    transform: "translate(91.221 1.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1767",
    "data-name": "Group 1767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1766",
    "data-name": "Group 1766"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 20.34,
    height: 24.288,
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1771",
    "data-name": "Group 1771",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1770",
    "data-name": "Group 1770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1769",
    "data-name": "Group 1769"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 91.922,
    height: 27.399,
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1774",
    "data-name": "Group 1774",
    transform: "translate(89.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1773",
    "data-name": "Group 1773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1772",
    "data-name": "Group 1772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M214.071,301.047h-22.72v-2.3h22.72a1.15,1.15,0,0,1,1.147,1.152h0A1.15,1.15,0,0,1,214.071,301.047Z",
    transform: "translate(-191.351 -298.743)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1777",
    "data-name": "Group 1777",
    transform: "translate(89.458 25.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1776",
    "data-name": "Group 1776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1775",
    "data-name": "Group 1775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M214.071,343.738h-22.72v-2.3h22.72a1.149,1.149,0,0,1,1.147,1.152h0A1.149,1.149,0,0,1,214.071,343.738Z",
    transform: "translate(-191.351 -341.434)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1780",
    "data-name": "Group 1780",
    transform: "translate(73.835 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1779",
    "data-name": "Group 1779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1778",
    "data-name": "Group 1778"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 10.86,
    height: 27.399,
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1783",
    "data-name": "Group 1783",
    transform: "translate(8.742 0.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1782",
    "data-name": "Group 1782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1781",
    "data-name": "Group 1781"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 10.86,
    height: 27.399,
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1787",
    "data-name": "Group 1787",
    transform: "translate(91.898 5.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1786",
    "data-name": "Group 1786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1785",
    "data-name": "Group 1785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1784",
    "data-name": "Group 1784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M215.184,308.186c0,.067-4.4.121-9.832.121s-9.832-.054-9.832-.121,4.4-.121,9.832-.121S215.184,308.119,215.184,308.186Z",
    transform: "translate(-195.52 -308.065)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1791",
    "data-name": "Group 1791",
    transform: "translate(91.898 9.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1790",
    "data-name": "Group 1790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1789",
    "data-name": "Group 1789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1788",
    "data-name": "Group 1788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M215.184,314.382c0,.067-4.4.121-9.832.121s-9.832-.054-9.832-.121,4.4-.122,9.832-.122S215.184,314.315,215.184,314.382Z",
    transform: "translate(-195.52 -314.26)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1795",
    "data-name": "Group 1795",
    transform: "translate(91.898 13.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1794",
    "data-name": "Group 1794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1793",
    "data-name": "Group 1793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1792",
    "data-name": "Group 1792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M215.184,322.011c0,.067-4.4.121-9.832.121s-9.832-.054-9.832-.121,4.4-.122,9.832-.122S215.184,321.944,215.184,322.011Z",
    transform: "translate(-195.52 -321.889)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1799",
    "data-name": "Group 1799",
    transform: "translate(91.898 18.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1798",
    "data-name": "Group 1798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1797",
    "data-name": "Group 1797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1796",
    "data-name": "Group 1796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M215.184,329.64c0,.067-4.4.121-9.832.121s-9.832-.054-9.832-.121,4.4-.121,9.832-.121S215.184,329.573,215.184,329.64Z",
    transform: "translate(-195.52 -329.519)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1803",
    "data-name": "Group 1803",
    transform: "translate(91.898 22.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1802",
    "data-name": "Group 1802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1801",
    "data-name": "Group 1801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1800",
    "data-name": "Group 1800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M215.184,337.269c0,.067-4.4.121-9.832.121s-9.832-.054-9.832-.121,4.4-.122,9.832-.122S215.184,337.2,215.184,337.269Z",
    transform: "translate(-195.52 -337.147)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1807",
    "data-name": "Group 1807",
    transform: "translate(26.641 11.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1806",
    "data-name": "Group 1806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1805",
    "data-name": "Group 1805"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 41.355,
    height: 4.934,
    fill: "#ebebeb"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1837",
    "data-name": "Group 1837",
    transform: "translate(8.584 27.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1811",
    "data-name": "Group 1811",
    transform: "translate(87.659 0.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1810",
    "data-name": "Group 1810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1809",
    "data-name": "Group 1809"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 20.652,
    height: 14.799,
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1814",
    "data-name": "Group 1814",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1813",
    "data-name": "Group 1813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1812",
    "data-name": "Group 1812"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 87.89,
    height: 15.873,
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1817",
    "data-name": "Group 1817",
    transform: "translate(87.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1816",
    "data-name": "Group 1816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1815",
    "data-name": "Group 1815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M192.781,346.427h22.2a.535.535,0,0,0,.534-.537h0a.535.535,0,0,0-.534-.537h-22.2Z",
    transform: "translate(-192.781 -345.353)",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1820",
    "data-name": "Group 1820",
    transform: "translate(87.251 14.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1819",
    "data-name": "Group 1819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1818",
    "data-name": "Group 1818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    d: "M0,0H22.313a.419.419,0,0,1,.419.419V.655a.419.419,0,0,1-.419.419H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1824",
    "data-name": "Group 1824",
    transform: "translate(87.89 3.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1823",
    "data-name": "Group 1823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1822",
    "data-name": "Group 1822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1821",
    "data-name": "Group 1821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M214.294,350.964c0,.068-4.572.122-10.21.122s-10.211-.054-10.211-.122,4.571-.121,10.211-.121S214.294,350.9,214.294,350.964Z",
    transform: "translate(-193.873 -350.843)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1828",
    "data-name": "Group 1828",
    transform: "translate(87.89 6.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1827",
    "data-name": "Group 1827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1826",
    "data-name": "Group 1826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1825",
    "data-name": "Group 1825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M214.294,355.727c0,.067-4.572.122-10.21.122s-10.211-.055-10.211-.122,4.571-.121,10.211-.121S214.294,355.66,214.294,355.727Z",
    transform: "translate(-193.873 -355.606)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1832",
    "data-name": "Group 1832",
    transform: "translate(87.89 8.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1831",
    "data-name": "Group 1831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1830",
    "data-name": "Group 1830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1829",
    "data-name": "Group 1829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M214.294,360.49c0,.067-4.572.122-10.21.122s-10.211-.055-10.211-.122,4.571-.121,10.211-.121S214.294,360.423,214.294,360.49Z",
    transform: "translate(-193.873 -360.369)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1836",
    "data-name": "Group 1836",
    transform: "translate(87.89 11.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1835",
    "data-name": "Group 1835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1834",
    "data-name": "Group 1834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1833",
    "data-name": "Group 1833"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M214.294,365.253c0,.067-4.572.122-10.21.122s-10.211-.055-10.211-.122,4.571-.121,10.211-.121S214.294,365.186,214.294,365.253Z",
    transform: "translate(-193.873 -365.132)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1878",
    "data-name": "Group 1878",
    transform: "translate(0 43.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1840",
    "data-name": "Group 1840",
    transform: "translate(98.948 1.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1839",
    "data-name": "Group 1839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1838",
    "data-name": "Group 1838"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 21.08,
    height: 40.118,
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1843",
    "data-name": "Group 1843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1842",
    "data-name": "Group 1842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1841",
    "data-name": "Group 1841"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 98.948,
    height: 43.498,
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1846",
    "data-name": "Group 1846",
    transform: "translate(96.243 40.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1845",
    "data-name": "Group 1845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1844",
    "data-name": "Group 1844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M218.913,444.376H193.478v-2.821h25.435a1.407,1.407,0,0,1,1.4,1.41h0A1.408,1.408,0,0,1,218.913,444.376Z",
    transform: "translate(-193.478 -441.555)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1849",
    "data-name": "Group 1849",
    transform: "translate(96.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1848",
    "data-name": "Group 1848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1847",
    "data-name": "Group 1847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    d: "M0,0H25.738a1.1,1.1,0,0,1,1.1,1.1V1.72a1.1,1.1,0,0,1-1.1,1.1H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1853",
    "data-name": "Group 1853",
    transform: "translate(98.948 6.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1852",
    "data-name": "Group 1852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1851",
    "data-name": "Group 1851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1850",
    "data-name": "Group 1850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M219.18,383.819c0,.067-4.719.121-10.54.121s-10.54-.054-10.54-.121,4.718-.121,10.54-.121S219.18,383.752,219.18,383.819Z",
    transform: "translate(-198.1 -383.698)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1857",
    "data-name": "Group 1857",
    transform: "translate(98.948 11.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1856",
    "data-name": "Group 1856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1855",
    "data-name": "Group 1855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1854",
    "data-name": "Group 1854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M219.18,392.572c0,.067-4.719.122-10.54.122s-10.54-.055-10.54-.122,4.718-.121,10.54-.121S219.18,392.505,219.18,392.572Z",
    transform: "translate(-198.1 -392.451)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1861",
    "data-name": "Group 1861",
    transform: "translate(98.948 16.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1860",
    "data-name": "Group 1860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1859",
    "data-name": "Group 1859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1858",
    "data-name": "Group 1858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M219.18,401.325c0,.067-4.719.122-10.54.122s-10.54-.055-10.54-.122,4.718-.121,10.54-.121S219.18,401.258,219.18,401.325Z",
    transform: "translate(-198.1 -401.204)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1865",
    "data-name": "Group 1865",
    transform: "translate(98.948 22.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1864",
    "data-name": "Group 1864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1863",
    "data-name": "Group 1863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1862",
    "data-name": "Group 1862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M219.18,410.078c0,.067-4.719.122-10.54.122s-10.54-.055-10.54-.122,4.718-.121,10.54-.121S219.18,410.011,219.18,410.078Z",
    transform: "translate(-198.1 -409.957)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1869",
    "data-name": "Group 1869",
    transform: "translate(98.948 27.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1868",
    "data-name": "Group 1868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1867",
    "data-name": "Group 1867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1866",
    "data-name": "Group 1866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M219.18,418.831c0,.068-4.719.122-10.54.122s-10.54-.054-10.54-.122,4.718-.121,10.54-.121S219.18,418.764,219.18,418.831Z",
    transform: "translate(-198.1 -418.71)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1873",
    "data-name": "Group 1873",
    transform: "translate(98.948 32.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1872",
    "data-name": "Group 1872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1871",
    "data-name": "Group 1871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1870",
    "data-name": "Group 1870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M219.18,427.585c0,.066-4.719.121-10.54.121s-10.54-.055-10.54-.121,4.718-.122,10.54-.122S219.18,427.518,219.18,427.585Z",
    transform: "translate(-198.1 -427.463)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1877",
    "data-name": "Group 1877",
    transform: "translate(98.948 37.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1876",
    "data-name": "Group 1876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1875",
    "data-name": "Group 1875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1874",
    "data-name": "Group 1874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M219.18,436.338c0,.067-4.719.121-10.54.121s-10.54-.054-10.54-.121,4.718-.122,10.54-.122S219.18,436.271,219.18,436.338Z",
    transform: "translate(-198.1 -436.216)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1886",
    "data-name": "Group 1886",
    transform: "translate(25.36 55.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1880",
    "data-name": "Group 1880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M80.861,405.247v2.421c0,2.915-1.451,4.58-4.249,4.58s-4.249-1.666-4.249-4.58v-9.474c0-2.914,1.451-4.58,4.249-4.58s4.249,1.666,4.249,4.58v1.77H78.167v-1.952c0-1.3-.57-1.8-1.477-1.8s-1.477.494-1.477,1.8v9.838c0,1.3.569,1.769,1.477,1.769s1.477-.469,1.477-1.769v-2.6Z",
    transform: "translate(-72.363 -393.614)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1881",
    "data-name": "Group 1881",
    transform: "translate(9.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M89.448,398.194c0-2.914,1.529-4.58,4.327-4.58s4.327,1.666,4.327,4.58v9.474c0,2.915-1.529,4.58-4.327,4.58s-4.327-1.666-4.327-4.58Zm2.85,9.656c0,1.3.57,1.8,1.477,1.8s1.477-.494,1.477-1.8v-9.838c0-1.3-.57-1.8-1.477-1.8s-1.477.494-1.477,1.8Z",
    transform: "translate(-89.448 -393.614)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1882",
    "data-name": "Group 1882",
    transform: "translate(20.491 0.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M107.375,393.969h2.85v15.615h4.69v2.6h-7.54Z",
    transform: "translate(-107.375 -393.969)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1883",
    "data-name": "Group 1883",
    transform: "translate(29.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M121.981,398.194c0-2.914,1.529-4.58,4.327-4.58s4.327,1.666,4.327,4.58v9.474c0,2.915-1.529,4.58-4.327,4.58s-4.327-1.666-4.327-4.58Zm2.85,9.656c0,1.3.57,1.8,1.477,1.8s1.477-.494,1.477-1.8v-9.838c0-1.3-.57-1.8-1.477-1.8s-1.477.494-1.477,1.8Z",
    transform: "translate(-121.981 -393.614)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1884",
    "data-name": "Group 1884",
    transform: "translate(39.401 0.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M142.537,393.969v14.053c0,1.3.57,1.769,1.477,1.769s1.477-.469,1.477-1.769V393.969h2.694V407.84c0,2.915-1.451,4.58-4.249,4.58s-4.249-1.666-4.249-4.58V393.969Z",
    transform: "translate(-139.687 -393.969)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1885",
    "data-name": "Group 1885",
    transform: "translate(49.841 0.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M163.485,412.186a5.617,5.617,0,0,1-.259-2.238v-2.863c0-1.692-.57-2.316-1.866-2.316h-.984v7.417h-2.85V393.969h4.3c2.954,0,4.224,1.379,4.224,4.189v1.431c0,1.874-.6,3.1-1.866,3.7,1.425.6,1.892,1.978,1.892,3.878v2.81a5.385,5.385,0,0,0,.311,2.212Zm-3.109-15.615v5.6h1.114c1.062,0,1.71-.469,1.71-1.926v-1.8c0-1.3-.441-1.874-1.451-1.874Z",
    transform: "translate(-157.525 -393.969)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1897",
    "data-name": "Group 1897",
    transform: "translate(31.164 32.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1887",
    "data-name": "Group 1887",
    transform: "translate(0 0.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M84.358,355.609H82.28l.109-.541H87.16l-.118.541h-2.07L83.9,360.984H83.29Z",
    transform: "translate(-82.28 -355.068)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1888",
    "data-name": "Group 1888",
    transform: "translate(3.001 1.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M93.289,357.569l-3.231,5.021c-.547.845-.959,1.106-1.6,1.106a1.433,1.433,0,0,1-1.052-.4l.32-.439a1.032,1.032,0,0,0,.782.321c.379,0,.673-.178,1.018-.718l.311-.473-1.1-4.421h.606l.917,3.786,2.414-3.786Z",
    transform: "translate(-87.408 -357.569)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1889",
    "data-name": "Group 1889",
    transform: "translate(8.509 1.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M102.112,359.389a2.5,2.5,0,0,1-2.507,2.645,1.655,1.655,0,0,1-1.683-.972l-.5,2.57h-.6l1.2-6.085H98.6l-.143.711a2.236,2.236,0,0,1,1.725-.744A1.792,1.792,0,0,1,102.112,359.389Zm-.605.034a1.3,1.3,0,0,0-1.456-1.386,1.936,1.936,0,0,0-1.91,2.087A1.293,1.293,0,0,0,99.6,361.5,1.934,1.934,0,0,0,101.507,359.423Z",
    transform: "translate(-96.82 -357.513)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1890",
    "data-name": "Group 1890",
    transform: "translate(14.498 1.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M107.052,360.149a2.517,2.517,0,0,1,2.558-2.636,1.816,1.816,0,0,1,2.011,1.876,2.52,2.52,0,0,1-2.558,2.645A1.827,1.827,0,0,1,107.052,360.149Zm3.971-.727a1.3,1.3,0,0,0-1.456-1.386,1.948,1.948,0,0,0-1.918,2.087,1.293,1.293,0,0,0,1.455,1.378A1.94,1.94,0,0,0,111.023,359.423Z",
    transform: "translate(-107.052 -357.513)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1891",
    "data-name": "Group 1891",
    transform: "translate(19.476 1.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M120.877,357.546l-.774,3.9a2.361,2.361,0,0,1-2.574,2.222,2.8,2.8,0,0,1-1.969-.668l.353-.456a2.308,2.308,0,0,0,1.657.591,1.734,1.734,0,0,0,1.918-1.588l.1-.491a2.286,2.286,0,0,1-1.767.762,1.757,1.757,0,0,1-1.952-1.792,2.45,2.45,0,0,1,2.524-2.518,1.7,1.7,0,0,1,1.725,1.014l.185-.981Zm-1.01,1.783c0-.811-.547-1.292-1.464-1.292a1.88,1.88,0,0,0-1.927,1.96c0,.811.538,1.293,1.464,1.293A1.886,1.886,0,0,0,119.867,359.329Z",
    transform: "translate(-115.559 -357.513)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1892",
    "data-name": "Group 1892",
    transform: "translate(25.582 1.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M129.1,357.513,129,358.1c-.059,0-.1-.009-.169-.009a1.754,1.754,0,0,0-1.792,1.648l-.446,2.257h-.6l.876-4.446h.572l-.152.811A2,2,0,0,1,129.1,357.513Z",
    transform: "translate(-125.991 -357.513)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1893",
    "data-name": "Group 1893",
    transform: "translate(28.802 1.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M136.458,357.546l-.883,4.446H135l.143-.7a2.263,2.263,0,0,1-1.725.744,1.788,1.788,0,0,1-1.927-1.884,2.5,2.5,0,0,1,2.5-2.636,1.661,1.661,0,0,1,1.683.963l.185-.93Zm-.992,1.877a1.3,1.3,0,0,0-1.456-1.386,1.947,1.947,0,0,0-1.918,2.087,1.293,1.293,0,0,0,1.456,1.378A1.941,1.941,0,0,0,135.466,359.423Z",
    transform: "translate(-131.494 -357.513)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1894",
    "data-name": "Group 1894",
    transform: "translate(34.218 1.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M146.04,359.389a2.5,2.5,0,0,1-2.507,2.645,1.655,1.655,0,0,1-1.683-.972l-.5,2.57h-.6l1.2-6.085h.572l-.143.711a2.235,2.235,0,0,1,1.725-.744A1.792,1.792,0,0,1,146.04,359.389Zm-.606.034a1.3,1.3,0,0,0-1.456-1.386,1.937,1.937,0,0,0-1.91,2.087,1.293,1.293,0,0,0,1.456,1.378A1.934,1.934,0,0,0,145.435,359.423Z",
    transform: "translate(-140.748 -357.513)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1895",
    "data-name": "Group 1895",
    transform: "translate(40.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M155.671,357.7a2.7,2.7,0,0,1-.051.507l-.5,2.527h-.6l.506-2.536a2.434,2.434,0,0,0,.042-.405c0-.634-.379-1-1.144-1a1.727,1.727,0,0,0-1.8,1.555l-.471,2.383h-.6l1.245-6.271h.6l-.5,2.492a2.154,2.154,0,0,1,1.691-.7A1.39,1.39,0,0,1,155.671,357.7Z",
    transform: "translate(-151.051 -354.464)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1896",
    "data-name": "Group 1896",
    transform: "translate(44.579 1.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M164.332,357.569,161.1,362.59c-.547.845-.959,1.106-1.6,1.106a1.431,1.431,0,0,1-1.052-.4l.319-.439a1.033,1.033,0,0,0,.782.321c.379,0,.673-.178,1.018-.718l.312-.473-1.1-4.421h.606l.917,3.786,2.415-3.786Z",
    transform: "translate(-158.451 -357.569)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1910",
    "data-name": "Group 1910",
    transform: "translate(5.186 0.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1901",
    "data-name": "Group 1901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1900",
    "data-name": "Group 1900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1899",
    "data-name": "Group 1899"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M127.661,46.789H37.891l14.624,10.6V78.241A4.345,4.345,0,0,0,56.849,82.6h70.811A4.345,4.345,0,0,0,132,78.241v-27.1A4.345,4.345,0,0,0,127.661,46.789Z",
    transform: "translate(-37.891 -46.789)",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1905",
    "data-name": "Group 1905",
    transform: "translate(25.549 14.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1904",
    "data-name": "Group 1904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1903",
    "data-name": "Group 1903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1902",
    "data-name": "Group 1902"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M142.022,71.749c0,.087-13.539.158-30.237.158s-30.24-.071-30.24-.158,13.536-.157,30.24-.157S142.022,71.662,142.022,71.749Z",
    transform: "translate(-81.546 -71.592)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1909",
    "data-name": "Group 1909",
    transform: "translate(25.549 22.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1908",
    "data-name": "Group 1908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1907",
    "data-name": "Group 1907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1906",
    "data-name": "Group 1906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M142.022,85.369c0,.087-13.539.158-30.237.158s-30.24-.071-30.24-.158,13.536-.158,30.24-.158S142.022,85.282,142.022,85.369Z",
    transform: "translate(-81.546 -85.211)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(22.733 280.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1911",
    "data-name": "Group 1911",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M432.718,446.246c0,.084-91.785.153-204.982.153-113.236,0-205-.069-205-.153s91.766-.153,205-.153C340.932,446.093,432.718,446.162,432.718,446.246Z",
    transform: "translate(-22.733 -446.093)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plants",
    transform: "translate(37.678 181.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1937",
    "data-name": "Group 1937",
    transform: "translate(331.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1932",
    "data-name": "Group 1932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1912",
    "data-name": "Group 1912",
    transform: "translate(0 17.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M639.66,358.983s-15.514-17.934-21.368-35.868-3.073-15.876-3.073-15.876,7.9,17.421,13.9,25.836,16.685,20.763,16.685,20.763Z",
    transform: "translate(-614.559 -307.167)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1913",
    "data-name": "Group 1913",
    transform: "translate(26.499 19.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M661.531,311.716a.9.9,0,0,0-1.683.577c.946,6.3,2.99,21.083,2.91,30.671-.1,12.455,0,17.27,0,17.27h6.456s-1.146-25.748-2.6-33.6A54.061,54.061,0,0,0,661.531,311.716Z",
    transform: "translate(-659.837 -311.25)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1914",
    "data-name": "Group 1914",
    transform: "translate(31.713 17.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M668.746,356.583a68.911,68.911,0,0,0,5.315-19.364c.532-4.585-.417-10.781-1.828-19.049a51.524,51.524,0,0,1-.816-9.166,1.539,1.539,0,0,1,2.892-.726,41.255,41.255,0,0,1,3.607,9.159c1.563,8.164,3.335,12.246,1.98,19.992s-6.356,19.678-6.356,19.678Z",
    transform: "translate(-668.746 -307.472)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1915",
    "data-name": "Group 1915",
    transform: "translate(37.529 7.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M678.684,350.145s17.033-36.766,18.214-42.22,5.195-18.024,5.667-17.312,1.18,7.351-1.889,14.94S684.5,351.266,684.5,351.266h-5.816",
    transform: "translate(-678.684 -290.584)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1917",
    "data-name": "Group 1917",
    transform: "translate(0.208 18.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1916",
    "data-name": "Group 1916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M644.554,355.676a3.476,3.476,0,0,1-.477-.329c-.3-.23-.761-.554-1.32-1.012a60.475,60.475,0,0,1-4.578-4.059,77.108,77.108,0,0,1-12.357-15.93,104.613,104.613,0,0,1-8.435-18.353c-.857-2.442-1.482-4.441-1.887-5.829-.208-.692-.351-1.236-.452-1.6a3.55,3.55,0,0,1-.132-.566,3.462,3.462,0,0,1,.2.545q.192.591.517,1.582c.447,1.374,1.108,3.358,1.994,5.784a111.188,111.188,0,0,0,8.506,18.253,80.471,80.471,0,0,0,12.225,15.933c1.823,1.82,3.383,3.207,4.486,4.133.543.474.987.815,1.275,1.063A3.5,3.5,0,0,1,644.554,355.676Z",
    transform: "translate(-614.914 -307.994)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1919",
    "data-name": "Group 1919",
    transform: "translate(27.339 20.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1918",
    "data-name": "Group 1918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M665.645,339.971a6.221,6.221,0,0,1-.153-1.079c-.081-.761-.187-1.753-.314-2.947-.27-2.487-.691-5.917-1.292-9.686s-1.275-7.159-1.8-9.606c-.252-1.175-.461-2.149-.622-2.9a6.223,6.223,0,0,1-.191-1.072,6.288,6.288,0,0,1,.329,1.038c.191.674.443,1.656.735,2.874.585,2.436,1.3,5.827,1.9,9.605s.984,7.221,1.189,9.719c.1,1.249.17,2.261.2,2.961A6.317,6.317,0,0,1,665.645,339.971Z",
    transform: "translate(-661.273 -312.684)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1921",
    "data-name": "Group 1921",
    transform: "translate(33.962 18.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1920",
    "data-name": "Group 1920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M674.328,308.353a2.6,2.6,0,0,1,.2.467c.13.346.3.8.511,1.366.225.592.484,1.323.731,2.189s.581,1.836.828,2.944q.2.828.422,1.729c.143.6.244,1.239.375,1.892.278,1.306.45,2.721.657,4.207a63.077,63.077,0,0,1-.694,19.435c-.312,1.467-.584,2.866-.954,4.149-.177.642-.324,1.27-.509,1.861s-.371,1.153-.544,1.694c-.325,1.086-.722,2.034-1.036,2.877s-.618,1.556-.885,2.13l-.607,1.326a2.7,2.7,0,0,1-.234.451,2.653,2.653,0,0,1,.167-.482l.543-1.35c.246-.582.537-1.3.825-2.148s.673-1.8.981-2.884q.249-.81.52-1.694c.178-.59.317-1.216.486-1.858.356-1.279.616-2.674.917-4.135a65.185,65.185,0,0,0,.69-19.334c-.2-1.478-.356-2.889-.62-4.19-.123-.652-.217-1.287-.352-1.887l-.4-1.727c-.229-1.106-.539-2.081-.773-2.947s-.466-1.6-.67-2.2l-.445-1.387A2.691,2.691,0,0,1,674.328,308.353Z",
    transform: "translate(-672.589 -308.353)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1923",
    "data-name": "Group 1923",
    transform: "translate(40.313 8.546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1922",
    "data-name": "Group 1922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M704.342,291.89a.564.564,0,0,1-.013.165c-.02.129-.045.286-.075.478-.075.419-.169,1.039-.336,1.83-.329,1.582-.877,3.858-1.729,6.619s-2.012,6-3.392,9.558-2.971,7.437-4.483,11.566c-1.536,4.121-2.719,8.144-3.83,11.794s-2.147,6.932-3.157,9.639a61.527,61.527,0,0,1-2.689,6.287c-.348.728-.662,1.271-.865,1.645l-.238.42a.579.579,0,0,1-.092.137.556.556,0,0,1,.059-.155l.207-.437c.181-.384.474-.936.8-1.672.686-1.457,1.609-3.6,2.576-6.314s1.993-5.99,3.077-9.648,2.27-7.69,3.809-11.823c1.516-4.138,3.123-8.013,4.513-11.562s2.581-6.768,3.459-9.514,1.466-5,1.836-6.571c.187-.784.3-1.4.4-1.813l.111-.471A.569.569,0,0,1,704.342,291.89Z",
    transform: "translate(-683.441 -291.89)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1931",
    "data-name": "Group 1931",
    transform: "translate(6.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1924",
    "data-name": "Group 1924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M627.649,277.777a1.467,1.467,0,0,0-2.414,1.5,42.134,42.134,0,0,0,2.14,5.528c2.342,5,9.22,22.932,12.44,32.781s7.757,28.224,7.757,28.224l6.876-1.12s-6.29-30.191-12.437-41.069C637.071,294.882,632.132,282.251,627.649,277.777Z",
    transform: "translate(-625.165 -277.351)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1926",
    "data-name": "Group 1926",
    transform: "translate(16.527 46.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1925",
    "data-name": "Group 1925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M653.409,356.279a4.271,4.271,0,0,1,.354.828c.2.541.48,1.332.793,2.318.633,1.97,1.408,4.722,2.189,7.779s1.427,5.84,1.88,7.857l.517,2.393a4.263,4.263,0,0,1,.142.889,4.363,4.363,0,0,1-.28-.856l-.63-2.365c-.526-2.077-1.217-4.808-1.982-7.828-.78-3.053-1.514-5.809-2.083-7.794l-.681-2.348A4.277,4.277,0,0,1,653.409,356.279Z",
    transform: "translate(-653.405 -356.279)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1928",
    "data-name": "Group 1928",
    transform: "translate(0.793 0.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1927",
    "data-name": "Group 1927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M651.587,345.468a.74.74,0,0,1-.039-.184l-.078-.544c-.073-.478-.136-1.186-.282-2.092-.252-1.814-.7-4.429-1.442-7.618A109.446,109.446,0,0,0,646.529,324c-1.41-4.091-3.179-8.512-5.183-13.087-4.045-9.14-8.086-17.246-10.741-23.241-1.343-2.991-2.381-5.432-3.066-7.133-.349-.847-.6-1.514-.773-1.964l-.191-.515a.726.726,0,0,1-.054-.18.706.706,0,0,1,.088.166l.225.5c.2.469.481,1.116.836,1.937.724,1.683,1.8,4.106,3.169,7.08,2.713,5.962,6.789,14.047,10.841,23.2,2.007,4.582,3.771,9.017,5.168,13.126A104.157,104.157,0,0,1,650,334.974a77.632,77.632,0,0,1,1.331,7.657c.124.909.166,1.622.214,2.1.017.223.031.4.042.548A.7.7,0,0,1,651.587,345.468Z",
    transform: "translate(-626.52 -277.878)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1930",
    "data-name": "Group 1930",
    transform: "translate(21.752 38.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1929",
    "data-name": "Group 1929"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M669.862,371.562a7.272,7.272,0,0,1-.232-1.16l-.536-3.175c-.474-2.676-1.2-6.361-2.237-10.372s-2.19-7.587-3.082-10.152l-1.076-3.033a7.44,7.44,0,0,1-.366-1.125,7.285,7.285,0,0,1,.5,1.073c.3.7.71,1.722,1.185,3a100.766,100.766,0,0,1,3.193,10.148,106.084,106.084,0,0,1,2.139,10.422c.2,1.348.345,2.439.422,3.2A7.39,7.39,0,0,1,669.862,371.562Z",
    transform: "translate(-662.332 -342.544)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1936",
    "data-name": "Group 1936",
    transform: "translate(17.23 66.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1933",
    "data-name": "Group 1933",
    transform: "translate(5.534)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 26.838,
    height: 32.843,
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1934",
    "data-name": "Group 1934",
    transform: "translate(5.534)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 26.838,
    height: 32.843
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1935",
    "data-name": "Group 1935"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 23.81,
    height: 32.843,
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2017",
    "data-name": "Group 2017",
    transform: "translate(0 50.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2010",
    "data-name": "Group 2010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M73.253,369.245a14.1,14.1,0,0,0-15.357.128c-4.224,2.966-6.369,8.363-6.183,13.537S54.4,394.4,59.063,397.121l13.7-.054A18.5,18.5,0,0,0,80.3,383.184,16.08,16.08,0,0,0,73.253,369.245Z",
    transform: "translate(-49.693 -365.256)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1939",
    "data-name": "Group 1939",
    transform: "translate(15.48 2.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1938",
    "data-name": "Group 1938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M76.056,397.969a6.225,6.225,0,0,1-.086-1.184c-.024-.846-.054-1.929-.091-3.227-.069-2.724-.176-6.486-.357-10.639s-.4-7.911-.574-10.631c-.077-1.3-.142-2.377-.191-3.222a6.136,6.136,0,0,1-.018-1.186,6.2,6.2,0,0,1,.187,1.172c.093.757.207,1.855.331,3.213.248,2.716.52,6.476.7,10.635s.239,7.927.229,10.654c0,1.364-.021,2.468-.048,3.23A6.139,6.139,0,0,1,76.056,397.969Z",
    transform: "translate(-74.72 -367.881)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1941",
    "data-name": "Group 1941",
    transform: "translate(0.113 16.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1940",
    "data-name": "Group 1940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M51.75,391.771c-.01.121-.754.158-1.662.083s-1.636-.233-1.626-.354.754-.158,1.662-.083S51.76,391.65,51.75,391.771Z",
    transform: "translate(-48.462 -391.378)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1943",
    "data-name": "Group 1943",
    transform: "translate(0.963 10.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1942",
    "data-name": "Group 1942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M52.608,383.288c-.049.111-.691-.068-1.433-.4s-1.306-.689-1.257-.8.691.068,1.434.4S52.657,383.177,52.608,383.288Z",
    transform: "translate(-49.915 -382.056)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1945",
    "data-name": "Group 1945",
    transform: "translate(3.356 6.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1944",
    "data-name": "Group 1944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M56.681,376.727c-.062.1-.784-.24-1.534-.866s-1.221-1.271-1.134-1.352.684.41,1.412,1.013S56.747,376.623,56.681,376.727Z",
    transform: "translate(-54.003 -374.5)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1947",
    "data-name": "Group 1947",
    transform: "translate(7.247 2.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1946",
    "data-name": "Group 1946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M61.831,370.933c-.111.049-.456-.494-.773-1.213s-.483-1.341-.372-1.39.456.494.772,1.213S61.941,370.883,61.831,370.933Z",
    transform: "translate(-60.652 -368.327)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1949",
    "data-name": "Group 1949",
    transform: "translate(11.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1948",
    "data-name": "Group 1948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M68.4,366.846c-.108.051-.48-.527-.727-1.328s-.269-1.488-.152-1.508.329.608.569,1.378S68.516,366.795,68.4,366.846Z",
    transform: "translate(-67.457 -364.009)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1951",
    "data-name": "Group 1951",
    transform: "translate(17.66 0.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1950",
    "data-name": "Group 1950"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M79.223,364.411c.114.04.044.534-.156,1.1s-.454,1-.568.956-.044-.534.156-1.1S79.109,364.371,79.223,364.411Z",
    transform: "translate(-78.445 -364.408)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1953",
    "data-name": "Group 1953",
    transform: "translate(21.441 2.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1952",
    "data-name": "Group 1952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M86.545,367.806c.083.089-.215.5-.665.917s-.88.684-.962.595.215-.5.665-.917S86.463,367.717,86.545,367.806Z",
    transform: "translate(-84.905 -367.789)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1955",
    "data-name": "Group 1955",
    transform: "translate(25.294 4.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1954",
    "data-name": "Group 1954"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M93.365,372.31c.068.1-.3.466-.811.817s-.989.554-1.056.454.295-.466.811-.817S93.3,372.209,93.365,372.31Z",
    transform: "translate(-91.489 -372.284)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1957",
    "data-name": "Group 1957",
    transform: "translate(27.341 8.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1956",
    "data-name": "Group 1956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M97.718,379.031c.047.111-.525.463-1.279.787s-1.4.494-1.45.382.525-.463,1.279-.787S97.671,378.919,97.718,379.031Z",
    transform: "translate(-94.986 -378.997)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1959",
    "data-name": "Group 1959",
    transform: "translate(28.56 13.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1958",
    "data-name": "Group 1958"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M99.725,386.314c.015.12-.568.292-1.3.383s-1.34.068-1.354-.052.567-.292,1.3-.383S99.71,386.194,99.725,386.314Z",
    transform: "translate(-97.07 -386.206)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1961",
    "data-name": "Group 1961",
    transform: "translate(29.21 17.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1960",
    "data-name": "Group 1960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M100.78,394.6c-.048.112-.668-.052-1.386-.366s-1.26-.657-1.211-.768.668.052,1.386.366S100.829,394.488,100.78,394.6Z",
    transform: "translate(-98.18 -393.43)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1963",
    "data-name": "Group 1963",
    transform: "translate(28.411 21.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1962",
    "data-name": "Group 1962"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M99.691,401.841c-.038.111-.823-.077-1.642-.618s-1.309-1.183-1.223-1.263.685.389,1.462.9S99.736,401.724,99.691,401.841Z",
    transform: "translate(-96.815 -399.949)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1965",
    "data-name": "Group 1965",
    transform: "translate(26.789 24.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1964",
    "data-name": "Group 1964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M96.18,408.611c-.072.094-.7-.275-1.3-.925s-.921-1.3-.823-1.367.567.447,1.143,1.068S96.257,408.514,96.18,408.611Z",
    transform: "translate(-94.044 -406.313)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1967",
    "data-name": "Group 1967",
    transform: "translate(3.372 27.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1966",
    "data-name": "Group 1966"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M57.165,411.034c.056.108-.6.561-1.464,1.013s-1.611.732-1.667.624.6-.561,1.465-1.013S57.109,410.926,57.165,411.034Z",
    transform: "translate(-54.03 -411.011)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1969",
    "data-name": "Group 1969",
    transform: "translate(1.925 23.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1968",
    "data-name": "Group 1968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M54.093,404.646c.05.111-.476.458-1.175.776s-1.305.486-1.355.376.476-.458,1.175-.777S54.042,404.536,54.093,404.646Z",
    transform: "translate(-51.559 -404.612)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1971",
    "data-name": "Group 1971",
    transform: "translate(0 20.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1970",
    "data-name": "Group 1970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M51.222,398.954c.017.12-.63.312-1.446.428s-1.491.113-1.507-.007.63-.312,1.446-.428S51.205,398.834,51.222,398.954Z",
    transform: "translate(-48.269 -398.862)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1973",
    "data-name": "Group 1973",
    transform: "translate(4.939 18.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1972",
    "data-name": "Group 1972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M59.66,395.865c.036.113-.6.409-1.438.5s-1.523-.05-1.513-.168.667-.175,1.464-.268S59.625,395.747,59.66,395.865Z",
    transform: "translate(-56.709 -395.81)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1975",
    "data-name": "Group 1975",
    transform: "translate(9.64 14.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1974",
    "data-name": "Group 1974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M67.094,388.881c.036.113-.467.369-1.145.434s-1.22-.083-1.207-.2.534-.171,1.165-.235S67.059,388.763,67.094,388.881Z",
    transform: "translate(-64.742 -388.812)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1977",
    "data-name": "Group 1977",
    transform: "translate(10.487 10.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1976",
    "data-name": "Group 1976"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M68.478,382.751c-.039.115-.583.03-1.215-.189s-1.111-.49-1.072-.6.583-.03,1.215.189S68.517,382.637,68.478,382.751Z",
    transform: "translate(-66.188 -381.906)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1979",
    "data-name": "Group 1979",
    transform: "translate(13.312 6.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1978",
    "data-name": "Group 1978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M71.984,376.589c-.084.084-.458-.163-.725-.629s-.294-.913-.18-.945.32.313.559.725S72.072,376.5,71.984,376.589Z",
    transform: "translate(-71.015 -375.013)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1981",
    "data-name": "Group 1981",
    transform: "translate(10.445 21.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1980",
    "data-name": "Group 1980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M68.139,400.772c.029.118-.442.335-1.052.484a4.015,4.015,0,0,1-.884.131l-.087-.256c.158-.029.26-.022.28.025s-.044.127-.171.224l-.087-.256a4.015,4.015,0,0,1,.845-.293C67.593,400.681,68.11,400.655,68.139,400.772Z",
    transform: "translate(-66.116 -400.699)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1983",
    "data-name": "Group 1983",
    transform: "translate(10.467 27.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1982",
    "data-name": "Group 1982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M69,410.7c.044.113-.557.456-1.341.766s-1.457.469-1.5.356.557-.456,1.342-.765S68.956,410.591,69,410.7Z",
    transform: "translate(-66.154 -410.667)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1985",
    "data-name": "Group 1985",
    transform: "translate(6.746 24.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1984",
    "data-name": "Group 1984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M61.729,406.287c.039.115-.362.356-.895.538s-1,.236-1.036.122.362-.356.895-.538S61.69,406.172,61.729,406.287Z",
    transform: "translate(-59.796 -406.227)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1987",
    "data-name": "Group 1987",
    transform: "translate(6.159 11.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1986",
    "data-name": "Group 1986"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M61.667,385.43c-.028.116-.725.047-1.531-.241s-1.392-.673-1.34-.781.7.089,1.487.367S61.7,385.31,61.667,385.43Z",
    transform: "translate(-58.793 -384.377)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1989",
    "data-name": "Group 1989",
    transform: "translate(18.244 11.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1988",
    "data-name": "Group 1988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M81.445,383.959c.066.1-.327.479-.877.844s-1.051.578-1.118.477.326-.479.877-.844S81.378,383.858,81.445,383.959Z",
    transform: "translate(-79.442 -383.934)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1991",
    "data-name": "Group 1991",
    transform: "translate(18.922 17.491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1990",
    "data-name": "Group 1990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M82.535,393.858c.025.118-.388.305-.922.416s-.986.105-1.011-.014.389-.305.922-.416S82.51,393.739,82.535,393.858Z",
    transform: "translate(-80.601 -393.764)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1993",
    "data-name": "Group 1993",
    transform: "translate(19.09 22.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1992",
    "data-name": "Group 1992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M83.362,404.277c-.051.111-.645-.058-1.327-.375s-1.194-.664-1.144-.774.645.058,1.327.376S83.413,404.167,83.362,404.277Z",
    transform: "translate(-80.888 -403.094)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1995",
    "data-name": "Group 1995",
    transform: "translate(18.658 28.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1994",
    "data-name": "Group 1994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M81.557,414.8c-.094.077-.479-.24-.862-.708s-.617-.91-.524-.987.479.24.861.708S81.65,414.722,81.557,414.8Z",
    transform: "translate(-80.151 -413.092)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1997",
    "data-name": "Group 1997",
    transform: "translate(18.261 7.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1996",
    "data-name": "Group 1996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M80.969,376.631c.074.093-.181.416-.618.635s-.846.233-.877.118.287-.31.681-.511S80.894,376.533,80.969,376.631Z",
    transform: "translate(-79.471 -376.599)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1999",
    "data-name": "Group 1999",
    transform: "translate(22.837 13.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1998",
    "data-name": "Group 1998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M89.706,386.644c.04.112-.469.393-1.164.489s-1.261-.033-1.252-.151.544-.192,1.192-.284S89.667,386.527,89.706,386.644Z",
    transform: "translate(-87.29 -386.586)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2001",
    "data-name": "Group 2001",
    transform: "translate(21.633 8.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2000",
    "data-name": "Group 2000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M87.759,377.656c.053.106-.451.468-1.169.7s-1.337.231-1.355.113.54-.312,1.222-.532S87.7,377.545,87.759,377.656Z",
    transform: "translate(-85.234 -377.621)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2003",
    "data-name": "Group 2003",
    transform: "translate(22.761 20.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2002",
    "data-name": "Group 2002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M90.852,400.135a5.269,5.269,0,0,1-3.689-.672,5.83,5.83,0,0,1,1.862.243A5.845,5.845,0,0,1,90.852,400.135Z",
    transform: "translate(-87.162 -399.425)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2005",
    "data-name": "Group 2005",
    transform: "translate(22.141 26.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2004",
    "data-name": "Group 2004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M88.371,412.113c-.072.094-.708-.282-1.342-.923s-1.007-1.28-.913-1.353.607.424,1.223,1.043S88.447,412.016,88.371,412.113Z",
    transform: "translate(-86.101 -409.83)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2007",
    "data-name": "Group 2007",
    transform: "translate(6.28 1.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2006",
    "data-name": "Group 2006"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M68.152,367.032a19.837,19.837,0,0,0-3.833,3.043,18.825,18.825,0,0,0-4.774,10.6,23.9,23.9,0,0,0,.289,6.495,49.693,49.693,0,0,0,1.211,5.212c.42,1.467.8,2.643,1.063,3.458a8.106,8.106,0,0,1,.368,1.279,7.392,7.392,0,0,1-.528-1.222c-.308-.8-.739-1.962-1.2-3.425a44.208,44.208,0,0,1-1.312-5.232,23.419,23.419,0,0,1-.325-6.615A18.515,18.515,0,0,1,64.1,369.859a13.715,13.715,0,0,1,2.86-2.244,8.51,8.51,0,0,1,.875-.457A1.027,1.027,0,0,1,68.152,367.032Z",
    transform: "translate(-59 -367.03)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2009",
    "data-name": "Group 2009",
    transform: "translate(15.101 1.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2008",
    "data-name": "Group 2008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M80.366,397.528a48.4,48.4,0,0,0,1.965-4.717,26.8,26.8,0,0,0,1.175-12.128,22.894,22.894,0,0,0-1.862-6.467,15.25,15.25,0,0,0-3.175-4.441,11.558,11.558,0,0,0-3.111-1.975c-.809-.339-1.293-.418-1.286-.455a1.066,1.066,0,0,1,.358.028,6.578,6.578,0,0,1,.99.268,10.754,10.754,0,0,1,3.253,1.9,15.022,15.022,0,0,1,3.334,4.5,22.54,22.54,0,0,1,1.931,6.581,25.892,25.892,0,0,1-1.316,12.29c-.247.758-.565,1.408-.8,1.994-.282.567-.514,1.059-.727,1.448A8.317,8.317,0,0,1,80.366,397.528Z",
    transform: "translate(-74.072 -367.338)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2011",
    "data-name": "Group 2011",
    transform: "translate(4.458 31.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M55.888,416.929h24.1l.148,4.845H55.888Z",
    transform: "translate(-55.888 -416.929)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2012",
    "data-name": "Group 2012",
    transform: "translate(6.506 33.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M59.387,421.05l1.385,14.791h17.62l1.415-14.629Z",
    transform: "translate(-59.387 -421.05)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2014",
    "data-name": "Group 2014",
    transform: "translate(4.465 35.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2013",
    "data-name": "Group 2013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M80.141,425.117c0,.121-5.427.219-12.121.219s-12.122-.1-12.122-.219,5.426-.22,12.122-.22S80.141,425,80.141,425.117Z",
    transform: "translate(-55.898 -424.897)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2016",
    "data-name": "Group 2016",
    transform: "translate(7.661 39.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2015",
    "data-name": "Group 2015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M79.958,431.905a3.672,3.672,0,0,1-.516.924,13.392,13.392,0,0,1-1.869,2.217l-.111.106-.109-.115a34.725,34.725,0,0,0-4.723-4.153l.266-.012L70.8,432.719l-2.476,2.165-.137.12-.138-.116-4.024-3.4.234-.026-2.082,2.552a5.923,5.923,0,0,1-.818.9,5.962,5.962,0,0,1,.673-1.012L64,431.261l.1-.135.134.109,4.084,3.325-.274,0,2.466-2.176,2.1-1.839.129-.113.138.1a30.876,30.876,0,0,1,4.7,4.288l-.221-.009A24.723,24.723,0,0,0,79.958,431.905Z",
    transform: "translate(-61.36 -430.437)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Device",
    transform: "translate(80.969 96.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2212",
    "data-name": "Group 2212",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2077",
    "data-name": "Group 2077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2038",
    "data-name": "Group 2038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2037",
    "data-name": "Group 2037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2036",
    "data-name": "Group 2036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2035",
    "data-name": "Group 2035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2030",
    "data-name": "Group 2030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2021",
    "data-name": "Group 2021",
    transform: "translate(8.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2020",
    "data-name": "Group 2020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2019",
    "data-name": "Group 2019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2018",
    "data-name": "Group 2018"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 272.172,
    height: 180.78,
    rx: 14.567,
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2025",
    "data-name": "Group 2025",
    transform: "translate(0 169.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2024",
    "data-name": "Group 2024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2023",
    "data-name": "Group 2023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2022",
    "data-name": "Group 2022"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    d: "M0,0H294.878a0,0,0,0,1,0,0V0A15.818,15.818,0,0,1,279.06,15.818H15.818A15.818,15.818,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2029",
    "data-name": "Group 2029",
    transform: "translate(118.166 167.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2028",
    "data-name": "Group 2028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2027",
    "data-name": "Group 2027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2026",
    "data-name": "Group 2026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M324.147,416.56l3.659,5.846H379.3l3.4-5.846Z",
    transform: "translate(-324.147 -416.56)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2034",
    "data-name": "Group 2034",
    transform: "translate(8.91 167.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2033",
    "data-name": "Group 2033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2032",
    "data-name": "Group 2032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2031",
    "data-name": "Group 2031"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M407.3,416.436c0,.1-60.409.177-134.91.177-74.527,0-134.923-.079-134.923-.177s60.4-.177,134.923-.177C346.888,416.259,407.3,416.338,407.3,416.436Z",
    transform: "translate(-137.464 -416.259)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2066",
    "data-name": "Group 2066",
    transform: "translate(16.431 10.395)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2065",
    "data-name": "Group 2065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2064",
    "data-name": "Group 2064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2043",
    "data-name": "Group 2043",
    transform: "translate(0.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2042",
    "data-name": "Group 2042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2041",
    "data-name": "Group 2041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2040",
    "data-name": "Group 2040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2039",
    "data-name": "Group 2039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    d: "M3.273,0H252.245a3.273,3.273,0,0,1,3.273,3.273V148.961a3.273,3.273,0,0,1-3.273,3.273H3.272A3.272,3.272,0,0,1,0,148.962V3.273A3.273,3.273,0,0,1,3.273,0Z",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2048",
    "data-name": "Group 2048",
    transform: "translate(0 11.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2047",
    "data-name": "Group 2047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2046",
    "data-name": "Group 2046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2045",
    "data-name": "Group 2045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2044",
    "data-name": "Group 2044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M405.833,309.888H150.315l.273-141.08H405.833Z",
    transform: "translate(-150.315 -168.808)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2053",
    "data-name": "Group 2053",
    transform: "translate(17.149 3.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2052",
    "data-name": "Group 2052"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2051",
    "data-name": "Group 2051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2050",
    "data-name": "Group 2050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2049",
    "data-name": "Group 2049"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M183.7,158.018a2.04,2.04,0,1,1-2.041-2.049A2.045,2.045,0,0,1,183.7,158.018Z",
    transform: "translate(-179.617 -155.969)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2058",
    "data-name": "Group 2058",
    transform: "translate(4.781 3.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2057",
    "data-name": "Group 2057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2056",
    "data-name": "Group 2056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2055",
    "data-name": "Group 2055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2054",
    "data-name": "Group 2054"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M162.565,158.018a2.041,2.041,0,1,1-2.041-2.049A2.045,2.045,0,0,1,162.565,158.018Z",
    transform: "translate(-158.483 -155.969)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2063",
    "data-name": "Group 2063",
    transform: "translate(10.717 3.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2062",
    "data-name": "Group 2062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2061",
    "data-name": "Group 2061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2060",
    "data-name": "Group 2060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2059",
    "data-name": "Group 2059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M172.709,158.018a2.041,2.041,0,1,1-2.041-2.049A2.045,2.045,0,0,1,172.709,158.018Z",
    transform: "translate(-168.627 -155.969)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 255.792,
    height: 13.623,
    transform: "translate(16.431 149.229)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2076",
    "data-name": "Group 2076",
    transform: "translate(23.951 153.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2067",
    "data-name": "Group 2067",
    transform: "translate(0 1.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M165.308,398.235v.436h-2.037v-.345l1.1-1.047c.269-.258.316-.42.316-.574,0-.254-.174-.4-.514-.4a.779.779,0,0,0-.647.289l-.359-.277a1.275,1.275,0,0,1,1.05-.46c.6,0,.987.305.987.8a1.112,1.112,0,0,1-.458.876l-.738.706Z",
    transform: "translate(-163.165 -395.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M167.3,397.331a.324.324,0,1,1,.647,0,.324.324,0,1,1-.647,0Zm0,1.511a.324.324,0,1,1,.647,0,.324.324,0,1,1-.647,0Z",
    transform: "translate(-164.88 -396.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M169.827,395.923V398.7h-.513v-2.344h-.584v-.432Z",
    transform: "translate(-165.473 -395.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M173.975,398.069h-.49v.63h-.5v-.63h-1.516v-.357l1.361-1.788h.549l-1.283,1.709h.9v-.56h.482v.56h.49Z",
    transform: "translate(-166.61 -395.883)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2068",
    "data-name": "Group 2068",
    transform: "translate(11.879 3.018)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 209.658,
    height: 0.96,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2069",
    "data-name": "Group 2069",
    transform: "translate(11.722 1.984)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 65.518,
    height: 2.56,
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2070",
    "data-name": "Group 2070",
    transform: "translate(72.976 0.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M294.237,396.256a3.19,3.19,0,1,1-3.19-3.2A3.2,3.2,0,0,1,294.237,396.256Z",
    transform: "translate(-287.857 -393.052)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2071",
    "data-name": "Group 2071",
    transform: "translate(224.61 1.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M549.159,397.079a.923.923,0,0,1-1.011.9c-.753,0-1.2-.487-1.2-1.38a1.312,1.312,0,0,1,1.354-1.475,1.381,1.381,0,0,1,.726.178l-.189.389a.935.935,0,0,0-.525-.135c-.521,0-.849.326-.849.956v0a.941.941,0,0,1,.738-.289A.865.865,0,0,1,549.159,397.079Zm-.5.024c0-.289-.217-.471-.552-.471a.5.5,0,0,0-.561.476c0,.261.205.467.572.467A.48.48,0,0,0,548.661,397.1Z",
    transform: "translate(-546.952 -395.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M551.15,396.6a.323.323,0,1,1,.647,0,.323.323,0,1,1-.647,0Zm0,1.511a.323.323,0,1,1,.647,0,.323.323,0,1,1-.647,0Z",
    transform: "translate(-548.693 -395.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M552.82,396.552c0-.912.5-1.428,1.152-1.428s1.157.516,1.157,1.428-.5,1.427-1.157,1.427S552.82,397.463,552.82,396.552Zm1.792,0c0-.67-.26-.979-.64-.979s-.635.309-.635.979.26.979.635.979S554.612,397.222,554.612,396.552Z",
    transform: "translate(-549.386 -395.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M557.354,396.552c0-.912.5-1.428,1.153-1.428s1.156.516,1.156,1.428-.5,1.427-1.156,1.427S557.354,397.463,557.354,396.552Zm1.793,0c0-.67-.26-.979-.64-.979s-.635.309-.635.979.26.979.635.979S559.147,397.222,559.147,396.552Z",
    transform: "translate(-551.266 -395.124)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2072",
    "data-name": "Group 2072",
    transform: "translate(236.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M568.251,395.318H567.3v-2.768h2.75v.96h-1.794Z",
    transform: "translate(-567.296 -392.551)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2073",
    "data-name": "Group 2073",
    transform: "translate(236.513 3.618)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M570.046,401.468H567.29v-2.762h.956v1.8h1.8Z",
    transform: "translate(-567.29 -398.705)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2074",
    "data-name": "Group 2074",
    transform: "translate(240.906 3.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M577.548,401.463H574.8v-.96h1.795v-1.808h.956Z",
    transform: "translate(-574.798 -398.695)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2075",
    "data-name": "Group 2075",
    transform: "translate(240.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M577.549,395.313h-.956v-1.8h-1.8v-.96h2.756Z",
    transform: "translate(-574.793 -392.551)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2211",
    "data-name": "Group 2211",
    transform: "translate(28.88 30.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2208",
    "data-name": "Group 2208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M194.177,183.078H179.116l-7.53,13.1,7.53,13.1h15.061l7.53-13.1Z",
    transform: "translate(-171.586 -183.078)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2207",
    "data-name": "Group 2207",
    transform: "translate(6.251 1.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2201",
    "data-name": "Group 2201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2078",
    "data-name": "Group 2078"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M184.775,199.54a13.5,13.5,0,0,1-1.842-2.385,4.556,4.556,0,0,1-.621-2.9c.1-.582.341-1.136.38-1.725.054-.809-.285-1.655,0-2.414.447-1.186,2.036-1.37,3-2.189.75-.638,1.116-1.674,1.941-2.211a3.634,3.634,0,0,1,2.5-.337,9.4,9.4,0,0,0,2.558.222,16.792,16.792,0,0,0,1.773-.477,2.411,2.411,0,0,1,1.787.122,1.171,1.171,0,0,1,.48,1.571,1.944,1.944,0,0,1,2.51,1.373,2.975,2.975,0,0,1-1.106,2.9,6.465,6.465,0,0,1-2.985,1.223,12.446,12.446,0,0,1-8.906-1.394",
    transform: "translate(-182.267 -185.01)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2200",
    "data-name": "Group 2200",
    transform: "translate(0.188 1.71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2174",
    "data-name": "Group 2174",
    transform: "translate(1.84 0.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2173",
    "data-name": "Group 2173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2172",
    "data-name": "Group 2172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2091",
    "data-name": "Group 2091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2090",
    "data-name": "Group 2090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2089",
    "data-name": "Group 2089"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M200.176,204.444c-.1-1.875-.624-5.719-1.137-9.193a7.223,7.223,0,0,0-7.619-6.169l-.372.025c-4,.506-5.813,4.2-5.2,8.21l1.175,14.43H196.8s-.231-2.532-.232-2.556C196.563,209.191,200.387,208.328,200.176,204.444Z",
    transform: "translate(-185.732 -189.066)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2088",
    "data-name": "Group 2088",
    transform: "translate(5.702 18.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2087",
    "data-name": "Group 2087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2086",
    "data-name": "Group 2086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2085",
    "data-name": "Group 2085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2084",
    "data-name": "Group 2084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2083",
    "data-name": "Group 2083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2082",
    "data-name": "Group 2082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2081",
    "data-name": "Group 2081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2080",
    "data-name": "Group 2080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2079",
    "data-name": "Group 2079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M200.606,222.435a8.971,8.971,0,0,1-5.132-1.1s1.377,2.712,5.208,2.1Z",
    transform: "translate(-195.474 -221.336)",
    fill: "#eb996e"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2171",
    "data-name": "Group 2171",
    transform: "translate(4.08 5.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2170",
    "data-name": "Group 2170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2149",
    "data-name": "Group 2149",
    transform: "translate(0.511 1.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2148",
    "data-name": "Group 2148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2147",
    "data-name": "Group 2147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2113",
    "data-name": "Group 2113",
    transform: "translate(5.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2101",
    "data-name": "Group 2101",
    transform: "translate(0.544 1.424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2100",
    "data-name": "Group 2100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2099",
    "data-name": "Group 2099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2098",
    "data-name": "Group 2098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2097",
    "data-name": "Group 2097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2096",
    "data-name": "Group 2096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2095",
    "data-name": "Group 2095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2094",
    "data-name": "Group 2094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2093",
    "data-name": "Group 2093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2092",
    "data-name": "Group 2092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M205.565,204.924a.554.554,0,0,1-.495.595.529.529,0,0,1-.6-.461.555.555,0,0,1,.495-.595A.53.53,0,0,1,205.565,204.924Z",
    transform: "translate(-204.466 -204.459)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2112",
    "data-name": "Group 2112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2111",
    "data-name": "Group 2111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2110",
    "data-name": "Group 2110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2109",
    "data-name": "Group 2109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2108",
    "data-name": "Group 2108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2107",
    "data-name": "Group 2107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2106",
    "data-name": "Group 2106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2105",
    "data-name": "Group 2105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2104",
    "data-name": "Group 2104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2103",
    "data-name": "Group 2103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2102",
    "data-name": "Group 2102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M205.719,202.549c-.064.077-.5-.206-1.1-.164s-1.008.369-1.077.3c-.034-.031.027-.166.207-.317a1.511,1.511,0,0,1,.857-.33,1.448,1.448,0,0,1,.878.221C205.68,202.388,205.751,202.515,205.719,202.549Z",
    transform: "translate(-203.537 -202.036)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2135",
    "data-name": "Group 2135",
    transform: "translate(0 0.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2123",
    "data-name": "Group 2123",
    transform: "translate(0.764 1.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2122",
    "data-name": "Group 2122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2121",
    "data-name": "Group 2121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2120",
    "data-name": "Group 2120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2119",
    "data-name": "Group 2119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2118",
    "data-name": "Group 2118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2117",
    "data-name": "Group 2117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2116",
    "data-name": "Group 2116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2115",
    "data-name": "Group 2115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2114",
    "data-name": "Group 2114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M195.983,205.61a.554.554,0,0,1-.5.594.529.529,0,0,1-.6-.461.555.555,0,0,1,.494-.595A.53.53,0,0,1,195.983,205.61Z",
    transform: "translate(-194.883 -205.144)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2134",
    "data-name": "Group 2134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2133",
    "data-name": "Group 2133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2132",
    "data-name": "Group 2132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2131",
    "data-name": "Group 2131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2130",
    "data-name": "Group 2130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2129",
    "data-name": "Group 2129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2128",
    "data-name": "Group 2128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2127",
    "data-name": "Group 2127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2126",
    "data-name": "Group 2126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2125",
    "data-name": "Group 2125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2124",
    "data-name": "Group 2124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M195.76,203.405c-.063.077-.5-.205-1.1-.164s-1.009.369-1.078.3c-.034-.031.026-.165.208-.317a1.511,1.511,0,0,1,.857-.33,1.452,1.452,0,0,1,.878.221C195.721,203.244,195.792,203.371,195.76,203.405Z",
    transform: "translate(-193.578 -202.892)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2146",
    "data-name": "Group 2146",
    transform: "translate(4.024 0.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2145",
    "data-name": "Group 2145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2144",
    "data-name": "Group 2144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2143",
    "data-name": "Group 2143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2142",
    "data-name": "Group 2142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2141",
    "data-name": "Group 2141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2140",
    "data-name": "Group 2140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2139",
    "data-name": "Group 2139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2138",
    "data-name": "Group 2138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2137",
    "data-name": "Group 2137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2136",
    "data-name": "Group 2136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M201.061,207.571a3.954,3.954,0,0,1,.953-.239c.15-.026.292-.066.311-.172a.781.781,0,0,0-.132-.444l-.526-1.129a20.024,20.024,0,0,1-1.209-2.966,20.084,20.084,0,0,1,1.443,2.861q.266.6.507,1.137a.882.882,0,0,1,.118.592.378.378,0,0,1-.234.239,1.016,1.016,0,0,1-.255.053A3.872,3.872,0,0,1,201.061,207.571Z",
    transform: "translate(-200.454 -202.62)",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2159",
    "data-name": "Group 2159",
    transform: "translate(0 0.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2158",
    "data-name": "Group 2158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2157",
    "data-name": "Group 2157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2156",
    "data-name": "Group 2156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2155",
    "data-name": "Group 2155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2154",
    "data-name": "Group 2154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2153",
    "data-name": "Group 2153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2152",
    "data-name": "Group 2152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2151",
    "data-name": "Group 2151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2150",
    "data-name": "Group 2150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M195.4,199.509c-.048.166-.646.129-1.337.26s-1.242.36-1.344.22c-.046-.066.042-.226.259-.4a2.358,2.358,0,0,1,2.042-.366C195.278,199.312,195.416,199.431,195.4,199.509Z",
    transform: "translate(-192.704 -199.134)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2169",
    "data-name": "Group 2169",
    transform: "translate(6.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2168",
    "data-name": "Group 2168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2167",
    "data-name": "Group 2167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2166",
    "data-name": "Group 2166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2165",
    "data-name": "Group 2165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2164",
    "data-name": "Group 2164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2163",
    "data-name": "Group 2163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2162",
    "data-name": "Group 2162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2161",
    "data-name": "Group 2161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2160",
    "data-name": "Group 2160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M205.259,199.611c-.1.143-.514.029-1.006.056-.493.009-.9.152-1.008.017-.046-.066.01-.206.184-.347a1.455,1.455,0,0,1,1.622-.058C205.234,199.407,205.3,199.543,205.259,199.611Z",
    transform: "translate(-203.23 -199.06)",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2196",
    "data-name": "Group 2196",
    transform: "translate(0 11.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2184",
    "data-name": "Group 2184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2183",
    "data-name": "Group 2183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2182",
    "data-name": "Group 2182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2181",
    "data-name": "Group 2181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2180",
    "data-name": "Group 2180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2179",
    "data-name": "Group 2179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2178",
    "data-name": "Group 2178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2177",
    "data-name": "Group 2177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2176",
    "data-name": "Group 2176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2175",
    "data-name": "Group 2175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M185.052,207.9c-.067-.024-2.707-.61-2.446,2.037s3.117,1.785,3.114,1.708S185.052,207.9,185.052,207.9Z",
    transform: "translate(-182.588 -207.832)",
    fill: "#ffbe9d"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2195",
    "data-name": "Group 2195",
    transform: "translate(0.683 0.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2194",
    "data-name": "Group 2194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2193",
    "data-name": "Group 2193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2192",
    "data-name": "Group 2192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2191",
    "data-name": "Group 2191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2190",
    "data-name": "Group 2190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2189",
    "data-name": "Group 2189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2188",
    "data-name": "Group 2188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2187",
    "data-name": "Group 2187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2186",
    "data-name": "Group 2186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2185",
    "data-name": "Group 2185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M185.036,211.411c-.013-.007-.043.037-.117.081a.458.458,0,0,1-.342.041,1.147,1.147,0,0,1-.627-.972,1.531,1.531,0,0,1,.064-.673.533.533,0,0,1,.31-.388.234.234,0,0,1,.283.1c.043.071.031.125.046.128s.052-.05.02-.157a.291.291,0,0,0-.12-.156.348.348,0,0,0-.26-.042.65.65,0,0,0-.439.458,1.579,1.579,0,0,0-.087.754,1.2,1.2,0,0,0,.782,1.076.493.493,0,0,0,.413-.112C185.038,211.475,185.046,211.415,185.036,211.411Z",
    transform: "translate(-183.754 -209.364)",
    fill: "#eb996e"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2199",
    "data-name": "Group 2199",
    transform: "translate(1.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2198",
    "data-name": "Group 2198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2197",
    "data-name": "Group 2197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M198.541,191.154c-.181,1.054-2.309,2.019-4.073,1.967-1.626-.048-2.429-.858-3.611-1.434-.748-.364-.748-.364-1.763-.2-.82.134-1.247,1.107-1.707,1.8.878,1.922.523,4.157.151,6.238a1.057,1.057,0,0,1-.267.633A.838.838,0,0,1,186.2,200a3.289,3.289,0,0,1-.832-1.682,10.983,10.983,0,0,1-.261-4.3,7.459,7.459,0,0,1,1.783-3.886,7.008,7.008,0,0,1,4.791-2.2,8.6,8.6,0,0,1,5.11,1.457,5.066,5.066,0,0,1,1.747,1.768",
    transform: "translate(-185.001 -187.919)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M200.66,212.837l-1.344-.629a.445.445,0,0,0-.244-.062.387.387,0,0,0-.232.158,1.259,1.259,0,0,0-.149,1.379,1.047,1.047,0,0,0,1.261.466,1.439,1.439,0,0,0,.745-1.27Z",
    transform: "translate(-189.02 -196.194)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2202",
    "data-name": "Group 2202",
    transform: "translate(9.315 15.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M199.842,214.09c.021.026-.28.217-.787.071a1.236,1.236,0,0,1-.7-.568,1.292,1.292,0,0,1-.088-1.106,1.338,1.338,0,0,1,.325-.49,1.254,1.254,0,0,1,.228-.172.388.388,0,0,1,.354-.021c.307.172.514.318.72.451.393.262.626.443.605.479s-.293-.078-.714-.292l-.717-.376c-.056-.015-.05-.015-.1.013a1,1,0,0,0-.166.134,1.1,1.1,0,0,0-.248.384,1.053,1.053,0,0,0,.05.862,1.088,1.088,0,0,0,.526.5A2.846,2.846,0,0,0,199.842,214.09Z",
    transform: "translate(-198.184 -211.77)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2203",
    "data-name": "Group 2203",
    transform: "translate(4.892 9.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M196.284,203.335c-.03,0-.026-.246-.143-.661a2.762,2.762,0,0,0-1.009-1.451,2.63,2.63,0,1,0,0,4.222A2.762,2.762,0,0,0,196.141,204c.117-.414.114-.662.143-.66.011,0,.018.061.022.178a2.056,2.056,0,0,1-.05.511,2.753,2.753,0,0,1-.993,1.594,2.84,2.84,0,0,1-2.716.446,2.9,2.9,0,0,1,0-5.458,2.84,2.84,0,0,1,2.716.446,2.754,2.754,0,0,1,.993,1.594,2.063,2.063,0,0,1,.05.511C196.3,203.274,196.294,203.335,196.284,203.335Z",
    transform: "translate(-190.627 -200.44)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2204",
    "data-name": "Group 2204",
    transform: "translate(11.606 8.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M207.615,202.943c-.029,0-.026-.24-.141-.643a2.687,2.687,0,0,0-.983-1.412,2.56,2.56,0,1,0,0,4.11,2.687,2.687,0,0,0,.983-1.412c.115-.4.112-.644.141-.643.011,0,.018.059.022.173a2,2,0,0,1-.049.5,2.68,2.68,0,0,1-.967,1.555,2.77,2.77,0,0,1-2.649.436,2.829,2.829,0,0,1,0-5.325,2.77,2.77,0,0,1,2.649.435,2.681,2.681,0,0,1,.967,1.555,2,2,0,0,1,.049.5C207.633,202.884,207.625,202.943,207.615,202.943Z",
    transform: "translate(-202.099 -200.119)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2205",
    "data-name": "Group 2205",
    transform: "translate(10.403 10.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M201.4,203.6c-.06.056-.321-.113-.672-.1s-.605.179-.668.126c-.081-.043.165-.424.663-.433S201.476,203.553,201.4,203.6Z",
    transform: "translate(-200.043 -203.192)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2206",
    "data-name": "Group 2206",
    transform: "translate(2.742 11.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M189.421,204.69c.05.068-.461.537-1.142,1.047a4,4,0,0,1-1.324.8c-.05-.068.461-.536,1.142-1.047A4.019,4.019,0,0,1,189.421,204.69Z",
    transform: "translate(-186.952 -204.682)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2209",
    "data-name": "Group 2209",
    transform: "translate(35.54 12.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M262.555,205.03c0,.084-6.771.153-15.12.153s-15.122-.069-15.122-.153,6.769-.153,15.122-.153S262.555,204.946,262.555,205.03Z",
    transform: "translate(-232.313 -204.877)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2210",
    "data-name": "Group 2210",
    transform: "translate(35.738 15.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M248.71,210.438c0,.085-3.6.153-8.029.153s-8.03-.069-8.03-.153,3.594-.153,8.03-.153S248.71,210.353,248.71,210.438Z",
    transform: "translate(-232.651 -210.285)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(150.802 87.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2410",
    "data-name": "Group 2410",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M433.726,245.093a23.13,23.13,0,0,1,10.86,14.09c2.823,10.157,11.468,36.609,11.468,36.609s4.94,5.837,5.469,10.16-.529,14.778-2.117,16.727a4.46,4.46,0,0,1-3.852,1.626l-20.793-1.98-8.188-55.066Z",
    transform: "translate(-318.297 -169.621)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M308.145,238.291s-14.867,4.683-18.572,8.759l12.174,56.883-.194,17.948h70.485c0-.887.633-59.592.633-59.592l4.234-23.037-25.053-4.43-4.94-3.9-27.875,1.418-4.234,4.253Z",
    transform: "translate(-261.475 -163.781)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2213",
    "data-name": "Group 2213",
    transform: "translate(40.127 122.727)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M322.317,326.614c-.217-.483-.527-1-1.044-1.111-.849-.176-1.417.832-1.705,1.653a74.882,74.882,0,0,1-9.26,18.159l-.181,8.733c4.11-3.473,8.161-7.193,10.78-11.9S324.529,331.529,322.317,326.614Z",
    transform: "translate(-310.127 -325.482)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M269.66,258.357s-4.9,6.708-6.933,11.086-18.889,41.156-19.907,44.952-3.633,15.762,4.069,18.535h15.838l15.9-32.287.813-37.475Z",
    transform: "translate(-241.562 -175.088)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2214",
    "data-name": "Group 2214",
    transform: "translate(2.89 131.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M265.79,343.737c-.021.024-.353-.313-1.082-.729a12.13,12.13,0,0,0-3.325-1.209,15.933,15.933,0,0,0-2.423-.342,9.611,9.611,0,0,0-2.778.182A10.35,10.35,0,0,0,250.851,345a14.528,14.528,0,0,0-3.019,5.638,28.257,28.257,0,0,0-.953,5.2c-.148,1.5-.2,2.73-.255,3.576-.025.4-.045.718-.061.974a1.442,1.442,0,0,1-.042.339,1.453,1.453,0,0,1-.02-.341c0-.257,0-.58,0-.977.016-.848.038-2.076.16-3.59a27,27,0,0,1,.9-5.264,14.581,14.581,0,0,1,3.06-5.761,10.519,10.519,0,0,1,5.5-3.434,9.726,9.726,0,0,1,2.856-.16,15.626,15.626,0,0,1,2.454.384,11.409,11.409,0,0,1,3.336,1.318,5.721,5.721,0,0,1,.785.585A1.445,1.445,0,0,1,265.79,343.737Z",
    transform: "translate(-246.501 -341.165)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2215",
    "data-name": "Group 2215",
    transform: "translate(14.669 127.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M266.627,334.516a1.849,1.849,0,0,1,.533-.086,9.013,9.013,0,0,1,1.469-.02,12.1,12.1,0,0,1,2.16.32,12.841,12.841,0,0,1,4.805,2.3,12.114,12.114,0,0,1,1.608,1.484,9.068,9.068,0,0,1,.909,1.159,1.839,1.839,0,0,1,.269.47c-.047.033-.476-.6-1.334-1.48a13.925,13.925,0,0,0-1.619-1.408A13.768,13.768,0,0,0,270.72,335a13.856,13.856,0,0,0-2.109-.378C267.394,334.508,266.631,334.574,266.627,334.516Z",
    transform: "translate(-266.627 -334.391)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2216",
    "data-name": "Group 2216",
    transform: "translate(10.736 125.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M278.159,331.16a3.4,3.4,0,0,1-.733-.056c-.467-.061-1.145-.129-1.983-.192a33.666,33.666,0,0,0-12.954,1.557c-.8.259-1.443.487-1.883.656a3.408,3.408,0,0,1-.7.228,3.364,3.364,0,0,1,.654-.339c.427-.2,1.062-.463,1.859-.751a29.824,29.824,0,0,1,13.042-1.567c.842.09,1.52.192,1.983.289A3.38,3.38,0,0,1,278.159,331.16Z",
    transform: "translate(-259.907 -330.542)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2217",
    "data-name": "Group 2217",
    transform: "translate(53.327 72.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M353.454,262.654a1.012,1.012,0,0,1-.161-.191c-.113-.152-.255-.344-.432-.581l-1.592-2.216-5.516-7.818.246-.035-2.786,8.217-.063.185-.16-.1-.329-.212a16.936,16.936,0,0,1-3.448-2.925,20.585,20.585,0,0,1-2.462-3.42,28.6,28.6,0,0,1-2.71-6.58,44.612,44.612,0,0,1-1.026-4.686l-.222-1.283c-.026-.146-.056-.254-.074-.327a.352.352,0,0,1-.037-.109,5.371,5.371,0,0,1,.449,1.7c.227,1.107.545,2.713,1.116,4.648a29.287,29.287,0,0,0,2.745,6.5,20.61,20.61,0,0,0,2.44,3.361,16.8,16.8,0,0,0,3.391,2.868l.322.208-.223.082,2.811-8.209.09-.262.156.227,5.426,7.882,1.527,2.261.4.607A1.047,1.047,0,0,1,353.454,262.654Z",
    transform: "translate(-332.68 -240.569)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2218",
    "data-name": "Group 2218",
    transform: "translate(92.297 122.052)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M399.422,324.334a32.274,32.274,0,0,0,4.073,19.076c3.28,5.73,8.085,10.836,14.073,13.577.194-5.838-.085-12.714.108-18.552Z",
    transform: "translate(-399.269 -324.334)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2224",
    "data-name": "Group 2224",
    transform: "translate(90.433 100.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M397.438,301.491s-2.56.714-.64,5.982,2.56,4.95,3.84,9.879,2.774,9.426,5.014,12.212,10.561,8.465,10.561,8.465l7.468-7.072a36.056,36.056,0,0,1-.935-8.85c.295-3.579,1.042-12.366.935-13.866a25.35,25.35,0,0,0-1.707-5.143v-2.492l-3.84-11.866s-2.133-.964-2.88,2.465l-1.28-3.639s-2.027-.326-2.56,3.853a42.192,42.192,0,0,0,.427,9.965l-1.067,7.286-1.6,4.929-1.387.214s-2.088-.573-3.231-4.519S400.319,300.634,397.438,301.491Z",
    transform: "translate(-396.084 -287.56)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2219",
    "data-name": "Group 2219",
    transform: "translate(16.777 17.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M433.071,332.49a1.186,1.186,0,0,1-.035-.27c-.014-.2-.032-.464-.054-.785-.038-.719-.091-1.713-.157-2.951-.115-2.559-.275-6.119-.462-10.275l.033.086a1.492,1.492,0,0,0-1.511-.4,2.207,2.207,0,0,0-1.384,1.019,10.016,10.016,0,0,0-.892,3.754l-1.142,8.469c-.177,1.3-.365,2.541-.618,3.687a24.089,24.089,0,0,1-.925,3.126,26.114,26.114,0,0,0-.8,2.545,7.82,7.82,0,0,0-.241,1.984,6.246,6.246,0,0,0,.3,1.681,2.451,2.451,0,0,1-.179-.411,4.684,4.684,0,0,1-.235-1.265,7.636,7.636,0,0,1,.194-2.027,24.824,24.824,0,0,1,.766-2.577,24.6,24.6,0,0,0,.882-3.109c.24-1.137.417-2.37.587-3.671.344-2.607.722-5.468,1.118-8.472.094-.67.166-1.331.283-1.991a5.242,5.242,0,0,1,.658-1.884,2.51,2.51,0,0,1,1.57-1.145,1.78,1.78,0,0,1,1.8.5l.032.038,0,.048c.142,4.158.264,7.72.352,10.28.032,1.239.057,2.234.076,2.954,0,.322.006.583.008.787A1.183,1.183,0,0,1,433.071,332.49Z",
    transform: "translate(-424.751 -317.551)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2220",
    "data-name": "Group 2220",
    transform: "translate(19.472 8.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M430.9,312.82a3.06,3.06,0,0,1-.315-.671,16.993,16.993,0,0,1-.625-1.921,19.353,19.353,0,0,1-.537-2.952,8.627,8.627,0,0,1-.032-1.789,3.833,3.833,0,0,1,.644-1.837,2.608,2.608,0,0,1,1.365-1.029l.115-.034.059.1c1.082,1.916,2.021,3.608,2.682,4.824l.765,1.438a.3.3,0,1,1-.092.053l-.843-1.393c-.707-1.19-1.679-2.863-2.771-4.773l.173.069a2.331,2.331,0,0,0-1.2.917,3.577,3.577,0,0,0-.6,1.694,8.645,8.645,0,0,0,.015,1.729,21.728,21.728,0,0,0,.466,2.927c.188.824.388,1.48.528,1.933A4.005,4.005,0,0,1,430.9,312.82Z",
    transform: "translate(-429.356 -302.586)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2221",
    "data-name": "Group 2221",
    transform: "translate(18.915 2.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M428.718,309.479a2.949,2.949,0,0,1-.07-.683c-.02-.506-.045-1.129-.075-1.865-.05-1.575-.1-3.751-.133-6.155a53.111,53.111,0,0,1,.095-6.168,9.533,9.533,0,0,1,.4-1.835,2.313,2.313,0,0,1,.274-.631,17.429,17.429,0,0,0-.459,2.49c-.149,1.556-.023,3.734,0,6.139.035,2.4.049,4.58.044,6.156-.009.737-.016,1.361-.022,1.866A2.973,2.973,0,0,1,428.718,309.479Z",
    transform: "translate(-428.403 -292.142)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2222",
    "data-name": "Group 2222",
    transform: "translate(12.913 27.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M418.15,346.738c-.043-.036.424-.589,1-1.591a13.258,13.258,0,0,0,.868-1.829,13.14,13.14,0,0,0,.873-4.855,13.227,13.227,0,0,0-.177-2.019c-.193-1.141-.438-1.823-.385-1.842a1.64,1.64,0,0,1,.212.464,8.53,8.53,0,0,1,.384,1.337,11.551,11.551,0,0,1,.246,2.055,12.236,12.236,0,0,1-.892,4.964,11.514,11.514,0,0,1-.945,1.838,8.519,8.519,0,0,1-.826,1.118C418.293,346.623,418.166,346.752,418.15,346.738Z",
    transform: "translate(-418.147 -334.603)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M436.373,348.976l6.481,2.259s6.187-3.214,10.454,0,7.973,11.686,6.8,15.115c0,0-2.945,3.652-5.185,4.188s-10.949-1.584-14.573-2.35-9.871-4.846-9.871-4.846Z",
    transform: "translate(-410.349 -312.874)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2223",
    "data-name": "Group 2223",
    transform: "translate(26.466 31.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M441.66,354.994a2.152,2.152,0,0,1-.069-.577c-.026-.441-.057-.964-.092-1.573-.068-1.328-.157-3.164-.185-5.2a51.906,51.906,0,0,1,.15-5.2c.057-.665.129-1.2.2-1.568a2.129,2.129,0,0,1,.134-.565c.048.008-.053.823-.115,2.148s-.09,3.159-.06,5.186c.037,1.987.07,3.783.1,5.193.007.665.005,1.2,0,1.577A2.152,2.152,0,0,1,441.66,354.994Z",
    transform: "translate(-441.306 -340.311)",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2225",
    "data-name": "Group 2225",
    transform: "translate(120.975 133.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M465.917,349.135a20.373,20.373,0,0,0-2.155-1.952,11.81,11.81,0,0,0-13.136-.727,20.5,20.5,0,0,0-2.356,1.7,3.258,3.258,0,0,1,.534-.581,10.578,10.578,0,0,1,1.711-1.307,11.608,11.608,0,0,1,13.376.741,10.551,10.551,0,0,1,1.558,1.488A3.235,3.235,0,0,1,465.917,349.135Z",
    transform: "translate(-448.27 -344.499)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2226",
    "data-name": "Group 2226",
    transform: "translate(119.016 130.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M463.7,341.421a12.7,12.7,0,0,0-2.7-1.493,11.876,11.876,0,0,0-7.3-.22,16.893,16.893,0,0,0-3.773,1.577,17.91,17.91,0,0,0-2.733,1.939c-.727.623-1.283,1.167-1.665,1.546a4.712,4.712,0,0,1-.61.574,4.12,4.12,0,0,1,.524-.655,20.3,20.3,0,0,1,1.609-1.627,16.734,16.734,0,0,1,2.734-2.021,16.426,16.426,0,0,1,3.832-1.628,11.657,11.657,0,0,1,7.456.313,8.576,8.576,0,0,1,1.995,1.131,5.544,5.544,0,0,1,.475.4C463.652,341.359,463.7,341.414,463.7,341.421Z",
    transform: "translate(-444.923 -338.953)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2227",
    "data-name": "Group 2227",
    transform: "translate(117.783 127.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M462.876,334.423c-.016.06-1.149-.287-3.031-.543a24.313,24.313,0,0,0-3.322-.212,24.067,24.067,0,0,0-7.992,1.413,24.417,24.417,0,0,0-3.05,1.338c-1.682.886-2.628,1.6-2.664,1.55a4.29,4.29,0,0,1,.648-.521,9.219,9.219,0,0,1,.8-.552c.323-.2.682-.447,1.108-.667a21.95,21.95,0,0,1,3.057-1.413,22.794,22.794,0,0,1,8.088-1.43,21.927,21.927,0,0,1,3.353.28c.476.06.9.169,1.269.247a8.856,8.856,0,0,1,.944.243A4.333,4.333,0,0,1,462.876,334.423Z",
    transform: "translate(-442.816 -333.386)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2228",
    "data-name": "Group 2228",
    transform: "translate(72.247 70.848)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M380.956,237.227a5.453,5.453,0,0,1,.449,1.73,16.962,16.962,0,0,1-.246,5.049,30.261,30.261,0,0,1-.837,3.519,26.819,26.819,0,0,1-1.7,3.91c-1.4,2.7-3.152,5.651-5.186,8.8l-.238.367v-.44c0-2.077-.006-4.258-.01-6.523l.228.109-5.466,4.432.047-.07a58.04,58.04,0,0,0-2.431,13.2,154.33,154.33,0,0,0,.233,20.2c.288,6.216.476,11.814.669,16.514s.355,8.5.5,11.129c.077,1.3.136,2.317.178,3.023.022.335.04.6.052.786s.008.269.008.269-.018-.09-.039-.266-.047-.45-.082-.784c-.065-.69-.149-1.708-.235-3.021-.177-2.625-.379-6.427-.593-11.127s-.458-10.3-.734-16.509a151.715,151.715,0,0,1-.256-20.241,57.908,57.908,0,0,1,2.455-13.263l.013-.042.035-.028,5.475-4.42.228-.184v.293c0,2.265-.007,4.445-.01,6.523l-.238-.072c4.02-6.263,7.29-11.7,7.794-16.107a17.47,17.47,0,0,0,.315-5.012,8.517,8.517,0,0,0-.24-1.3C380.994,237.379,380.956,237.227,380.956,237.227Z",
    transform: "translate(-365.009 -237.227)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M373.036,366.217l-.209-.008a1.655,1.655,0,1,0,.209.008Z",
    transform: "translate(-295.34 -219.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2229",
    "data-name": "Group 2229",
    transform: "translate(75.884 100.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M373.036,327.675l-.209-.007a1.65,1.65,0,1,0,.209.007Z",
    transform: "translate(-371.224 -304.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M372.818,290.874a1.659,1.659,0,0,0,.219-3.308l-.209-.008a1.659,1.659,0,0,0-.01,3.315Z",
    transform: "translate(-371.224 -287.559)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2369",
    "data-name": "Group 2369",
    transform: "translate(44.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2363",
    "data-name": "Group 2363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2230",
    "data-name": "Group 2230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M325.354,161a41.133,41.133,0,0,1-5.618-7.271,13.888,13.888,0,0,1-1.893-8.847c.29-1.774,1.041-3.465,1.159-5.259.164-2.468-.869-5.048,0-7.362,1.362-3.616,6.209-4.175,9.147-6.674,2.288-1.946,3.4-5.1,5.92-6.741,2.2-1.43,5.024-1.4,7.618-1.03s5.2,1.026,7.8.675a51.229,51.229,0,0,0,5.406-1.453,7.349,7.349,0,0,1,5.45.373c1.615.942,2.521,3.244,1.462,4.789,3.009-1.393,6.83.962,7.653,4.185s-.825,6.705-3.374,8.83-5.846,3.114-9.1,3.731c-9.216,1.745-19.214.76-27.157-4.25",
    transform: "translate(-317.706 -116.703)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2362",
    "data-name": "Group 2362",
    transform: "translate(0.572 5.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2336",
    "data-name": "Group 2336",
    transform: "translate(5.611 2.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2335",
    "data-name": "Group 2335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2334",
    "data-name": "Group 2334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2253",
    "data-name": "Group 2253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2252",
    "data-name": "Group 2252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2251",
    "data-name": "Group 2251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2240",
    "data-name": "Group 2240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2239",
    "data-name": "Group 2239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2238",
    "data-name": "Group 2238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2237",
    "data-name": "Group 2237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2236",
    "data-name": "Group 2236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2235",
    "data-name": "Group 2235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2234",
    "data-name": "Group 2234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2233",
    "data-name": "Group 2233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2232",
    "data-name": "Group 2232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2231",
    "data-name": "Group 2231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M362.136,197.224c-.45-3.5-.818-6.428-.841-6.791,0,0,11.659-2.632,11.017-14.472-.31-5.723-1.9-17.456-3.47-28.055a22.015,22.015,0,0,0-23.227-18.785l-1.137.076c-12.207,1.542-17.723,12.818-15.85,25.032l6.587,40.954s2.81,9.06,8.823,10.628l7.588,10.887,1.254-4.686,5.656-4.945a22.347,22.347,0,0,0,2.788-4.169A9.16,9.16,0,0,0,362.136,197.224Z",
    transform: "translate(-328.27 -129.07)",
    fill: "#ffbe9d"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2250",
    "data-name": "Group 2250",
    transform: "translate(17.385 57.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2249",
    "data-name": "Group 2249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2248",
    "data-name": "Group 2248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2247",
    "data-name": "Group 2247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2246",
    "data-name": "Group 2246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2245",
    "data-name": "Group 2245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2244",
    "data-name": "Group 2244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2243",
    "data-name": "Group 2243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2242",
    "data-name": "Group 2242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2241",
    "data-name": "Group 2241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M373.624,230.815a27.35,27.35,0,0,1-15.649-3.352s4.2,8.271,15.88,6.416Z",
    transform: "translate(-357.975 -227.463)",
    fill: "#eb996e"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2333",
    "data-name": "Group 2333",
    transform: "translate(12.441 17.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2332",
    "data-name": "Group 2332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2311",
    "data-name": "Group 2311",
    transform: "translate(1.559 5.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2310",
    "data-name": "Group 2310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2309",
    "data-name": "Group 2309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2275",
    "data-name": "Group 2275",
    transform: "translate(17.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2263",
    "data-name": "Group 2263",
    transform: "translate(1.658 4.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2262",
    "data-name": "Group 2262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2261",
    "data-name": "Group 2261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2260",
    "data-name": "Group 2260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2259",
    "data-name": "Group 2259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2258",
    "data-name": "Group 2258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2257",
    "data-name": "Group 2257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2256",
    "data-name": "Group 2256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2255",
    "data-name": "Group 2255"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2254",
    "data-name": "Group 2254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M388.744,177.424a1.692,1.692,0,0,1-1.509,1.814,1.614,1.614,0,0,1-1.835-1.407,1.692,1.692,0,0,1,1.506-1.815A1.615,1.615,0,0,1,388.744,177.424Z",
    transform: "translate(-385.392 -176.003)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2274",
    "data-name": "Group 2274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2273",
    "data-name": "Group 2273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2272",
    "data-name": "Group 2272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2271",
    "data-name": "Group 2271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2270",
    "data-name": "Group 2270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2269",
    "data-name": "Group 2269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2268",
    "data-name": "Group 2268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2267",
    "data-name": "Group 2267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2266",
    "data-name": "Group 2266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2265",
    "data-name": "Group 2265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2264",
    "data-name": "Group 2264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M389.214,170.181c-.194.234-1.531-.628-3.342-.5-1.81.1-3.075,1.125-3.286.915-.1-.092.082-.5.633-.966a4.61,4.61,0,0,1,2.613-1.005,4.427,4.427,0,0,1,2.678.673C389.095,169.69,389.31,170.076,389.214,170.181Z",
    transform: "translate(-382.558 -168.616)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2297",
    "data-name": "Group 2297",
    transform: "translate(0 1.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2285",
    "data-name": "Group 2285",
    transform: "translate(2.33 4.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2284",
    "data-name": "Group 2284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2283",
    "data-name": "Group 2283"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2282",
    "data-name": "Group 2282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2281",
    "data-name": "Group 2281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2280",
    "data-name": "Group 2280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2279",
    "data-name": "Group 2279"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2278",
    "data-name": "Group 2278"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2277",
    "data-name": "Group 2277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2276",
    "data-name": "Group 2276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M359.525,179.513a1.691,1.691,0,0,1-1.509,1.813,1.613,1.613,0,0,1-1.835-1.407,1.692,1.692,0,0,1,1.507-1.815A1.615,1.615,0,0,1,359.525,179.513Z",
    transform: "translate(-356.173 -178.092)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2296",
    "data-name": "Group 2296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2295",
    "data-name": "Group 2295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2294",
    "data-name": "Group 2294"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2293",
    "data-name": "Group 2293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2292",
    "data-name": "Group 2292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2291",
    "data-name": "Group 2291"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2290",
    "data-name": "Group 2290"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2289",
    "data-name": "Group 2289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2288",
    "data-name": "Group 2288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2287",
    "data-name": "Group 2287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2286",
    "data-name": "Group 2286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M358.848,172.791c-.194.235-1.533-.627-3.342-.5-1.809.1-3.075,1.125-3.287.915-.1-.092.081-.5.634-.966a4.611,4.611,0,0,1,2.613-1.006,4.434,4.434,0,0,1,2.678.674C358.728,172.3,358.944,172.686,358.848,172.791Z",
    transform: "translate(-352.192 -171.226)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2308",
    "data-name": "Group 2308",
    transform: "translate(12.27 1.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2307",
    "data-name": "Group 2307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2306",
    "data-name": "Group 2306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2305",
    "data-name": "Group 2305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2304",
    "data-name": "Group 2304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2303",
    "data-name": "Group 2303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2302",
    "data-name": "Group 2302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2301",
    "data-name": "Group 2301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2300",
    "data-name": "Group 2300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2299",
    "data-name": "Group 2299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2298",
    "data-name": "Group 2298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M375.012,185.493a11.959,11.959,0,0,1,2.9-.731c.459-.079.89-.2.947-.523a2.372,2.372,0,0,0-.4-1.355q-.764-1.642-1.6-3.444c-2.233-4.905-3.883-8.952-3.686-9.041s2.168,3.816,4.4,8.722q.809,1.816,1.547,3.468a2.706,2.706,0,0,1,.361,1.806,1.164,1.164,0,0,1-.715.73,3.129,3.129,0,0,1-.778.162A11.737,11.737,0,0,1,375.012,185.493Z",
    transform: "translate(-373.159 -170.398)",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2321",
    "data-name": "Group 2321",
    transform: "translate(0 0.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2320",
    "data-name": "Group 2320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2319",
    "data-name": "Group 2319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2318",
    "data-name": "Group 2318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2317",
    "data-name": "Group 2317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2316",
    "data-name": "Group 2316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2315",
    "data-name": "Group 2315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2314",
    "data-name": "Group 2314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2313",
    "data-name": "Group 2313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2312",
    "data-name": "Group 2312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M357.736,160.912c-.146.506-1.969.393-4.075.793-2.115.357-3.785,1.1-4.1.672-.139-.2.128-.689.789-1.214a7.188,7.188,0,0,1,6.226-1.117C357.379,160.31,357.8,160.672,357.736,160.912Z",
    transform: "translate(-349.528 -159.766)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2331",
    "data-name": "Group 2331",
    transform: "translate(18.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2330",
    "data-name": "Group 2330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2329",
    "data-name": "Group 2329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2328",
    "data-name": "Group 2328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2327",
    "data-name": "Group 2327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2326",
    "data-name": "Group 2326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2325",
    "data-name": "Group 2325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2324",
    "data-name": "Group 2324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2323",
    "data-name": "Group 2323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2322",
    "data-name": "Group 2322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M387.81,161.224c-.291.434-1.567.089-3.067.17-1.5.028-2.751.463-3.072.051-.142-.2.03-.628.559-1.056a4.432,4.432,0,0,1,4.947-.178C387.734,160.6,387.937,161.013,387.81,161.224Z",
    transform: "translate(-381.623 -159.542)",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2358",
    "data-name": "Group 2358",
    transform: "translate(0 35.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2346",
    "data-name": "Group 2346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2345",
    "data-name": "Group 2345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2344",
    "data-name": "Group 2344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2343",
    "data-name": "Group 2343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2342",
    "data-name": "Group 2342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2341",
    "data-name": "Group 2341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2340",
    "data-name": "Group 2340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2339",
    "data-name": "Group 2339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2338",
    "data-name": "Group 2338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2337",
    "data-name": "Group 2337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M326.2,186.509c-.207-.074-8.254-1.861-7.458,6.21s9.5,5.441,9.5,5.208S326.2,186.509,326.2,186.509Z",
    transform: "translate(-318.684 -186.291)",
    fill: "#ffbe9d"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2357",
    "data-name": "Group 2357",
    transform: "translate(2.082 2.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2356",
    "data-name": "Group 2356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2355",
    "data-name": "Group 2355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2354",
    "data-name": "Group 2354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2353",
    "data-name": "Group 2353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2352",
    "data-name": "Group 2352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2351",
    "data-name": "Group 2351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2350",
    "data-name": "Group 2350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2349",
    "data-name": "Group 2349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2348",
    "data-name": "Group 2348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2347",
    "data-name": "Group 2347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M326.149,197.2c-.038-.022-.131.112-.356.245a1.4,1.4,0,0,1-1.044.125c-.88-.229-1.728-1.511-1.911-2.962a4.684,4.684,0,0,1,.193-2.052,1.63,1.63,0,0,1,.947-1.184.714.714,0,0,1,.864.3c.13.215.095.381.139.391.025.018.16-.152.062-.48a.9.9,0,0,0-.366-.474,1.059,1.059,0,0,0-.794-.128,1.982,1.982,0,0,0-1.339,1.4,4.816,4.816,0,0,0-.263,2.3c.212,1.621,1.191,3.061,2.386,3.282a1.5,1.5,0,0,0,1.259-.341C326.154,197.4,326.178,197.213,326.149,197.2Z",
    transform: "translate(-322.24 -190.96)",
    fill: "#eb996e"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2361",
    "data-name": "Group 2361",
    transform: "translate(4.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2360",
    "data-name": "Group 2360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2359",
    "data-name": "Group 2359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M367.326,135.435c-.552,3.213-7.04,6.157-12.419,6-4.959-.145-7.409-2.616-11.012-4.373-2.28-1.112-2.28-1.112-5.375-.606-2.5.409-3.8,3.374-5.206,5.493,2.676,5.859,1.594,12.674.46,19.02a3.232,3.232,0,0,1-.813,1.929c-.9.8-2.368.32-3.257-.5a10.029,10.029,0,0,1-2.536-5.128,33.5,33.5,0,0,1-.8-13.126,22.754,22.754,0,0,1,5.437-11.851,21.374,21.374,0,0,1,14.608-6.7A26.217,26.217,0,0,1,362,130.045a15.446,15.446,0,0,1,5.327,5.39",
    transform: "translate(-326.043 -125.571)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M373.787,201.551l-4.1-1.919a1.374,1.374,0,0,0-.745-.189,1.188,1.188,0,0,0-.709.483,3.841,3.841,0,0,0-.454,4.2,3.194,3.194,0,0,0,3.844,1.42c1.451-.6,2.157-2.3,2.271-3.871Z",
    transform: "translate(-338.297 -150.803)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2364",
    "data-name": "Group 2364",
    transform: "translate(28.561 48.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M371.406,205.474c.012.035-.189.154-.6.24a3.537,3.537,0,0,1-1.763-.13,3.681,3.681,0,0,1-2.034-1.7,3.808,3.808,0,0,1-.25-3.245,3.966,3.966,0,0,1,.951-1.439,3.651,3.651,0,0,1,.664-.5,1.079,1.079,0,0,1,.472-.151,1.066,1.066,0,0,1,.475.092,5.947,5.947,0,0,1,.638.364l.558.344,1,.627a8.972,8.972,0,0,1,1.9,1.363,8.938,8.938,0,0,1-2.119-.989l-1.035-.562-.574-.317a6.434,6.434,0,0,0-.579-.306.431.431,0,0,0-.448.043,3.232,3.232,0,0,0-.538.429,3.493,3.493,0,0,0-.8,1.227,3.333,3.333,0,0,0,.173,2.755,3.384,3.384,0,0,0,1.692,1.563,3.992,3.992,0,0,0,1.587.3C371.171,205.467,371.393,205.429,371.406,205.474Z",
    transform: "translate(-366.508 -198.545)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2365",
    "data-name": "Group 2365",
    transform: "translate(15.229 27.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M360.665,172.769a14.631,14.631,0,0,0-.32-2.043,8.406,8.406,0,0,0-3.06-4.571,8.228,8.228,0,0,0-7.823-1.17,8.276,8.276,0,0,0-3.827,2.89,8.277,8.277,0,0,0,0,9.787,8.276,8.276,0,0,0,3.828,2.892,8.227,8.227,0,0,0,7.824-1.17,8.408,8.408,0,0,0,3.06-4.571,14.631,14.631,0,0,0,.32-2.043.458.458,0,0,1,.009.137c0,.109,0,.241,0,.4a3.905,3.905,0,0,1-.051.653,5.923,5.923,0,0,1-.157.881,7.976,7.976,0,0,1-.908,2.275,8.441,8.441,0,0,1-10.186,3.7,8.527,8.527,0,0,1-3.973-2.979,8.551,8.551,0,0,1,0-10.142,8.527,8.527,0,0,1,3.972-2.978,8.491,8.491,0,0,1,4.479-.356,8.48,8.48,0,0,1,5.707,4.057,7.963,7.963,0,0,1,.908,2.275,6.01,6.01,0,0,1,.157.881,3.9,3.9,0,0,1,.051.652c0,.161,0,.293,0,.4A.452.452,0,0,1,360.665,172.769Z",
    transform: "translate(-343.728 -164.217)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2366",
    "data-name": "Group 2366",
    transform: "translate(35.701 27.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M395.215,171.575a14.465,14.465,0,0,0-.313-1.991,8.189,8.189,0,0,0-2.982-4.452,8.013,8.013,0,0,0-7.62-1.139,8.059,8.059,0,0,0-3.727,2.815,8.063,8.063,0,0,0,0,9.532,8.067,8.067,0,0,0,3.728,2.816,8.012,8.012,0,0,0,7.62-1.14,8.188,8.188,0,0,0,2.982-4.452,14.466,14.466,0,0,0,.313-1.99,3.375,3.375,0,0,1,0,.525,3.856,3.856,0,0,1-.05.636,5.741,5.741,0,0,1-.153.859,8.245,8.245,0,0,1-6.447,6.173,8.276,8.276,0,0,1-4.366-.346,8.315,8.315,0,0,1-3.873-2.9,8.338,8.338,0,0,1,0-9.887,8.314,8.314,0,0,1,3.873-2.9,8.279,8.279,0,0,1,4.365-.346,8.244,8.244,0,0,1,6.447,6.173,5.8,5.8,0,0,1,.153.859,3.855,3.855,0,0,1,.05.636A3.385,3.385,0,0,1,395.215,171.575Z",
    transform: "translate(-378.708 -163.238)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2367",
    "data-name": "Group 2367",
    transform: "translate(31.763 32.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M376.069,173.6c-.033.035-.227-.129-.582-.3a3.349,3.349,0,0,0-1.474-.324,3.308,3.308,0,0,0-1.461.376c-.349.183-.535.356-.569.323s.108-.258.457-.507a2.881,2.881,0,0,1,3.153-.055C375.95,173.352,376.1,173.58,376.069,173.6Z",
    transform: "translate(-371.979 -172.674)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2368",
    "data-name": "Group 2368",
    transform: "translate(8.369 35.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M339.526,176.726a72.315,72.315,0,0,1-7.517,5.637,72.263,72.263,0,0,1,7.517-5.637Z",
    transform: "translate(-332.007 -176.723)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2370",
    "data-name": "Group 2370",
    transform: "translate(53.396 73.544)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M332.929,241.813c-.814,7.978,2.206,16.4,8.576,21.233a1.931,1.931,0,0,0,1.717.541,1.89,1.89,0,0,0,.889-.921,15.635,15.635,0,0,0,1.9-10.25c-1.009,2.668-1.875,5.287-2.893,8.078C337.566,257.108,334.106,249.91,332.929,241.813Z",
    transform: "translate(-332.799 -241.813)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M369.871,259.44l4.674-1.714.774,7.94s5.044-9.234,7.132-13.447,1.014-11.648,1.014-11.648.747,6.476-4.308,14.738l-3.815,6.228v-6.523Z",
    transform: "translate(-294.779 -167.757)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2371",
    "data-name": "Group 2371",
    transform: "translate(4.227 131.068)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M265.27,340.646a12.445,12.445,0,0,0-6.773-.854,13.029,13.029,0,0,0-6.741,2.562,7.571,7.571,0,0,0-2.944,6.39l.234.034c1.631-4.434,4.876-7.661,9.059-8.051a13.714,13.714,0,0,1,11.137,4.56C268.963,342.989,267.355,341.634,265.27,340.646Z",
    transform: "translate(-248.784 -339.671)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2372",
    "data-name": "Group 2372",
    transform: "translate(121.622 133.261)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M466.678,346.716a10.7,10.7,0,0,0-6.037-3.124,13.528,13.528,0,0,0-11.264,3.275l.892-.727a14.163,14.163,0,0,1,7.5-2.047,10.833,10.833,0,0,1,7.151,2.869,19.163,19.163,0,0,1,3.8,6.136A7.712,7.712,0,0,0,466.678,346.716Z",
    transform: "translate(-449.376 -343.401)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2373",
    "data-name": "Group 2373",
    transform: "translate(108.787 83.654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M427.448,275.054a2.9,2.9,0,0,1,.21-.642l.664-1.708c.566-1.44,1.343-3.432,2.163-5.645s1.527-4.231,2.036-5.693l.609-1.729a2.871,2.871,0,0,1,.259-.623,2.842,2.842,0,0,1-.146.659c-.112.419-.288,1.021-.517,1.762-.457,1.481-1.134,3.513-1.955,5.732s-1.632,4.2-2.25,5.621c-.308.71-.566,1.281-.754,1.672A2.859,2.859,0,0,1,427.448,275.054Z",
    transform: "translate(-427.445 -259.013)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2374",
    "data-name": "Group 2374",
    transform: "translate(32.457 87.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M299.572,278.478c-.083.017-.719-2.78-1.42-6.247s-1.2-6.292-1.122-6.309.718,2.78,1.42,6.248S299.655,278.462,299.572,278.478Z",
    transform: "translate(-297.021 -265.922)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2381",
    "data-name": "Group 2381",
    transform: "translate(6.46 96.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2379",
    "data-name": "Group 2379",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M297.974,319.92c.185.093-2.144-18.318-2.144-18.318s1.47-13.972,2.3-14.619l.022-4.93s2.275-1.384,2.886.851c0,0,2.017-1.759,2.37,2.429s.427,8.468.427,8.468l4.49,11.277.74.376s.964-8.835,1.526-10.135.945-4.462,3.074-3.987,2.306,2.243,1.923,5.126a42.452,42.452,0,0,0-.682,7.719c.177,1.862,1.02,5.959.761,9.214a18.409,18.409,0,0,1-3.9,9.1c-1.863,2.411-5.421,7.4-7.356,8.9C303.733,331.917,297.974,319.92,297.974,319.92Z",
    transform: "translate(-270.53 -281.63)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2375",
    "data-name": "Group 2375",
    transform: "translate(27.696 5.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M301.938,308.859a3.928,3.928,0,0,1,.012-.788c.039-.565.088-1.283.147-2.139.137-1.8.347-4.3.6-7.046l.366-3.876a6.937,6.937,0,0,0,.02-1.662,2.358,2.358,0,0,0-.56-1.271,2.515,2.515,0,0,0-1.833-.808,4.8,4.8,0,0,0-.764.1c0-.01.058-.042.183-.1a1.973,1.973,0,0,1,.578-.121,2.488,2.488,0,0,1,2.646,2.158,7,7,0,0,1,.01,1.727c-.106,1.2-.221,2.507-.342,3.879-.251,2.75-.5,5.238-.687,7.038l-.243,2.13A3.873,3.873,0,0,1,301.938,308.859Z",
    transform: "translate(-299.924 -291.145)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2376",
    "data-name": "Group 2376",
    transform: "translate(29.544 15.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M305.661,308.469a6.358,6.358,0,0,0-.795,1.453,24.653,24.653,0,0,0-.746,3.974c-.242,1.574-.478,3-.664,4.024a9.29,9.29,0,0,1-.363,1.652,9.313,9.313,0,0,1,.15-1.685c.132-1.036.334-2.464.575-4.037a19.066,19.066,0,0,1,.847-4.006,3.806,3.806,0,0,1,.648-1.074C305.511,308.547,305.651,308.458,305.661,308.469Z",
    transform: "translate(-303.081 -308.468)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2377",
    "data-name": "Group 2377",
    transform: "translate(30.465 1.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M304.664,283.386a2.315,2.315,0,0,1,.156.579c.082.376.184.924.295,1.6.224,1.358.469,3.247.624,5.343s.187,4,.164,5.378c-.01.688-.031,1.245-.057,1.63a2.29,2.29,0,0,1-.07.6,19.5,19.5,0,0,1-.088-2.224c-.032-1.373-.1-3.268-.253-5.356s-.365-3.973-.533-5.335A19.462,19.462,0,0,1,304.664,283.386Z",
    transform: "translate(-304.655 -283.386)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2378",
    "data-name": "Group 2378",
    transform: "translate(40.722 17.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M324.885,312.169a1.627,1.627,0,0,1-1.512.129c-.859-.258-1.259-.922-1.183-.955a3.945,3.945,0,0,0,2.7.825Z",
    transform: "translate(-322.181 -311.339)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M280.3,342.873l-11.862,5.007h-7.067s-6.991,2.191-8.066,8.773-1.23,9.969,1.844,10.783,11.753.9,16.055-.53,15.57-10.567,15.57-10.567l1.086-6.607Z",
    transform: "translate(-252.6 -306.872)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2380",
    "data-name": "Group 2380",
    transform: "translate(26.907 32.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M302.143,347.664c-.015.014-.134-.1-.337-.311a7.294,7.294,0,0,1-.771-.985,13.492,13.492,0,0,1-1.657-3.768,22.428,22.428,0,0,1-.73-4.049,7.608,7.608,0,0,1-.046-1.7,12.382,12.382,0,0,1,.26,1.678,30.473,30.473,0,0,0,.81,3.99,15.787,15.787,0,0,0,1.546,3.737C301.751,347.143,302.185,347.626,302.143,347.664Z",
    transform: "translate(-298.575 -336.849)",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2382",
    "data-name": "Group 2382",
    transform: "translate(36.731 125.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M309.691,347.357a12.33,12.33,0,0,0,.676-2.554,8.261,8.261,0,0,0-1.593-5.979c-.721-1.014-1.531-1.9-2.214-2.752a12.742,12.742,0,0,1-1.6-2.435,6.408,6.408,0,0,1-.595-1.879,2.179,2.179,0,0,1-.02-.722,8.179,8.179,0,0,0,.808,2.5,13.634,13.634,0,0,0,1.628,2.354c.688.837,1.508,1.717,2.245,2.754a8.6,8.6,0,0,1,1.479,3.26,8.344,8.344,0,0,1,.079,2.926,7.544,7.544,0,0,1-.544,1.892,4.12,4.12,0,0,1-.239.478C309.737,347.308,309.7,347.361,309.691,347.357Z",
    transform: "translate(-304.323 -331.035)",
    fill: "#eb996e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2409",
    "data-name": "Group 2409",
    transform: "translate(6.995 70.678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2383",
    "data-name": "Group 2383",
    transform: "translate(11.304 32.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M278.342,302.49a118.594,118.594,0,0,1-5.51-10.706,118.843,118.843,0,0,1,5.51,10.706Z",
    transform: "translate(-272.828 -291.783)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2384",
    "data-name": "Group 2384",
    transform: "translate(35.996 12.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M315.024,267.418a74.068,74.068,0,0,1,3.852-8.684,73.927,73.927,0,0,1-3.852,8.684Z",
    transform: "translate(-315.019 -258.733)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2385",
    "data-name": "Group 2385",
    transform: "translate(49.642 29.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M343.481,292.814a53.622,53.622,0,0,1-5.142-6.239,53.6,53.6,0,0,1,5.142,6.239Z",
    transform: "translate(-338.336 -286.573)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2386",
    "data-name": "Group 2386",
    transform: "translate(50.461 48.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M339.74,325.586a44.37,44.37,0,0,1,4.3-5.954,44.263,44.263,0,0,1-4.3,5.954Z",
    transform: "translate(-339.736 -319.631)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2387",
    "data-name": "Group 2387",
    transform: "translate(41.02 73.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M327.231,369.766a5.663,5.663,0,0,1-.687-1.181c-.384-.749-.883-1.8-1.384-2.987s-.909-2.276-1.18-3.075a5.726,5.726,0,0,1-.369-1.316,6.5,6.5,0,0,1,.571,1.24l1.26,3.031,1.3,3.014A6.536,6.536,0,0,1,327.231,369.766Z",
    transform: "translate(-323.604 -361.206)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2388",
    "data-name": "Group 2388",
    transform: "translate(54.127 68.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M353.049,355.237a42.076,42.076,0,0,1-7.049-1.37,42.193,42.193,0,0,1,7.049,1.37Z",
    transform: "translate(-346 -353.85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2389",
    "data-name": "Group 2389",
    transform: "translate(73.992 37.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M379.945,307.9a86.97,86.97,0,0,1,7-7.582,87.48,87.48,0,0,1-7,7.582Z",
    transform: "translate(-379.943 -300.321)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2390",
    "data-name": "Group 2390",
    transform: "translate(78.67 68.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M396.155,363.527c-.065.053-1.958-2.146-4.227-4.913s-4.057-5.054-3.992-5.108,1.957,2.146,4.227,4.914S396.22,363.473,396.155,363.527Z",
    transform: "translate(-387.935 -353.504)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2391",
    "data-name": "Group 2391",
    transform: "translate(0 64.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M260.351,346.114c.043.085-1.686.965-3.57,2.418s-3.2,2.884-3.265,2.82a4.447,4.447,0,0,1,.8-1,18.945,18.945,0,0,1,4.87-3.731A4.414,4.414,0,0,1,260.351,346.114Z",
    transform: "translate(-253.514 -346.11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2392",
    "data-name": "Group 2392",
    transform: "translate(8.651 51.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M271.3,324.02a24.314,24.314,0,0,1-3,4.536,24.266,24.266,0,0,1,3-4.536Z",
    transform: "translate(-268.295 -324.018)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2393",
    "data-name": "Group 2393",
    transform: "translate(21.305 58.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M291.135,342.2A7.808,7.808,0,0,1,290,337.173c.091,0,.121,1.16.439,2.542S291.218,342.158,291.135,342.2Z",
    transform: "translate(-289.918 -337.173)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2394",
    "data-name": "Group 2394",
    transform: "translate(19.581 23.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M291.525,276.774a17.331,17.331,0,0,1-4.553.65,17.338,17.338,0,0,1,4.553-.65Z",
    transform: "translate(-286.972 -276.741)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2395",
    "data-name": "Group 2395",
    transform: "translate(28.198 8.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M305.791,252.067a18.035,18.035,0,0,1-4.095,2.279,17.981,17.981,0,0,1,4.095-2.279Z",
    transform: "translate(-301.695 -252.059)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2396",
    "data-name": "Group 2396",
    transform: "translate(50.965 9.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M344.872,258.565a41.032,41.032,0,0,1-4.272-5.635,41.113,41.113,0,0,1,4.272,5.635Z",
    transform: "translate(-340.596 -252.928)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2397",
    "data-name": "Group 2397",
    transform: "translate(80.822 23.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M395.161,283.374a14.391,14.391,0,0,1-3.541-5.716c.083-.036.713,1.336,1.691,2.907S395.229,283.315,395.161,283.374Z",
    transform: "translate(-391.613 -277.657)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2398",
    "data-name": "Group 2398",
    transform: "translate(92.79 33.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M414.759,293.644a35.043,35.043,0,0,1-2.69,5.955,35.155,35.155,0,0,1,2.69-5.955Z",
    transform: "translate(-412.062 -293.643)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2399",
    "data-name": "Group 2399",
    transform: "translate(91.36 11.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M415.3,262.906a64.937,64.937,0,0,1-5.679-6.855,65.086,65.086,0,0,1,5.679,6.855Z",
    transform: "translate(-409.619 -256.05)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2400",
    "data-name": "Group 2400",
    transform: "translate(79.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M390.1,242.648a26.831,26.831,0,0,1-.224-5.71,26.926,26.926,0,0,1,.224,5.71Z",
    transform: "translate(-389.797 -236.938)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2401",
    "data-name": "Group 2401",
    transform: "translate(86.638 4.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M408.818,245.323a44,44,0,0,1-7.268.976,44.01,44.01,0,0,1,7.268-.976Z",
    transform: "translate(-401.55 -245.299)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2402",
    "data-name": "Group 2402",
    transform: "translate(111.633 12.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M448.338,266.778a72.23,72.23,0,0,1-4.074-8.459,72.471,72.471,0,0,1,4.074,8.459Z",
    transform: "translate(-444.259 -258.318)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2403",
    "data-name": "Group 2403",
    transform: "translate(112.023 28.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M444.943,291.708a37.55,37.55,0,0,1,1.319-6.632,37.535,37.535,0,0,1-1.319,6.632Z",
    transform: "translate(-444.926 -285.076)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2404",
    "data-name": "Group 2404",
    transform: "translate(118.965 36.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M459.977,308.6a76.751,76.751,0,0,1-3.184-9.135,76.751,76.751,0,0,1,3.184,9.135Z",
    transform: "translate(-456.787 -299.462)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2405",
    "data-name": "Group 2405",
    transform: "translate(115.287 49.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M455.962,323.822a10.277,10.277,0,0,1-5.457-2.969c.06-.07,1.138.825,2.646,1.638S455.989,323.734,455.962,323.822Z",
    transform: "translate(-450.503 -320.849)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2406",
    "data-name": "Group 2406",
    transform: "translate(131.872 62.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M480.672,347.891a16.663,16.663,0,0,1-1.821-4.11,16.594,16.594,0,0,1,1.821,4.11Z",
    transform: "translate(-478.841 -343.779)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2407",
    "data-name": "Group 2407",
    transform: "translate(56.534 82.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M350.756,381.776a22.91,22.91,0,0,1-.607-5.241,22.925,22.925,0,0,1,.607,5.241Z",
    transform: "translate(-350.113 -376.535)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2408",
    "data-name": "Group 2408",
    transform: "translate(96.911 81.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M419.125,380.209a21.708,21.708,0,0,1,1.064-5.027,21.791,21.791,0,0,1-1.064,5.027Z",
    transform: "translate(-419.105 -375.182)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble",
    transform: "translate(262.351 81.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2443",
    "data-name": "Group 2443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2423",
    "data-name": "Group 2423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2422",
    "data-name": "Group 2422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2421",
    "data-name": "Group 2421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2420",
    "data-name": "Group 2420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2414",
    "data-name": "Group 2414",
    transform: "translate(0 0.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2413",
    "data-name": "Group 2413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2412",
    "data-name": "Group 2412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2411",
    "data-name": "Group 2411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M432.164,153.059l5.141-9.1a24.212,24.212,0,1,1,20.644,11.593,24.053,24.053,0,0,1-14.83-5.1l.008.011Z",
    transform: "translate(-432.164 -106.874)",
    fill: "#fafafa"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2419",
    "data-name": "Group 2419",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2418",
    "data-name": "Group 2418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2417",
    "data-name": "Group 2417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2416",
    "data-name": "Group 2416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2415",
    "data-name": "Group 2415"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M432.165,152.976l10.979-2.52.113-.026-.071-.092-.008-.011-.1.105a24.828,24.828,0,0,0,4.985,3.019,24.24,24.24,0,0,0,6.647,1.906,21.771,21.771,0,0,0,3.838.2c.66-.038,1.333-.054,2.01-.111l2.048-.311a24.51,24.51,0,0,0,19.245-19.173,24.941,24.941,0,0,0-.286-10.831,24.064,24.064,0,0,0-5.2-10.014l-.99-1.094c-.325-.368-.713-.671-1.066-1.009-.369-.319-.7-.681-1.1-.963l-1.163-.874a10.188,10.188,0,0,0-1.205-.8l-1.23-.75-1.288-.628a11.237,11.237,0,0,0-1.3-.58,24.627,24.627,0,0,0-10.866-1.677,23.837,23.837,0,0,0-9.973,2.961,24.675,24.675,0,0,0-11.506,14.221,26.407,26.407,0,0,0-1.053,7.919,24.309,24.309,0,0,0,1.187,6.837,24.754,24.754,0,0,0,2.432,5.239v-.073l-5.078,9.135,5.2-9.064.021-.036-.023-.037a24.749,24.749,0,0,1-2.385-5.219,24.2,24.2,0,0,1-1.149-6.788,26.292,26.292,0,0,1,1.07-7.845,24.465,24.465,0,0,1,11.416-14.049,23.583,23.583,0,0,1,9.861-2.913,24.367,24.367,0,0,1,10.735,1.665,11.077,11.077,0,0,1,1.284.574l1.271.621,1.214.741a10.01,10.01,0,0,1,1.19.791l1.149.863c.392.279.72.636,1.085.951.348.334.732.633,1.053,1l.978,1.08a23.78,23.78,0,0,1,5.134,9.89,24.654,24.654,0,0,1,.291,10.7,24.083,24.083,0,0,1-4.038,9.3,24.23,24.23,0,0,1-14.969,9.7l-2.028.314c-.671.059-1.337.076-1.991.116a21.533,21.533,0,0,1-3.8-.18,24.122,24.122,0,0,1-6.6-1.863,24.8,24.8,0,0,1-4.968-2.971l-.451-.347.346.451.008.011.042-.119Z",
    transform: "translate(-432.165 -106.673)",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2442",
    "data-name": "Group 2442",
    transform: "translate(13.08 21.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2429",
    "data-name": "Group 2429",
    transform: "translate(19.248 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2428",
    "data-name": "Group 2428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2427",
    "data-name": "Group 2427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2426",
    "data-name": "Group 2426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2425",
    "data-name": "Group 2425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2424",
    "data-name": "Group 2424"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M487.4,144.883a2.368,2.368,0,1,0,2.368-2.378A2.373,2.373,0,0,0,487.4,144.883Z",
    transform: "translate(-487.402 -142.505)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2435",
    "data-name": "Group 2435",
    transform: "translate(9.77 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2434",
    "data-name": "Group 2434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2433",
    "data-name": "Group 2433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2432",
    "data-name": "Group 2432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2431",
    "data-name": "Group 2431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2430",
    "data-name": "Group 2430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M471.208,144.883a2.368,2.368,0,1,0,2.369-2.378A2.373,2.373,0,0,0,471.208,144.883Z",
    transform: "translate(-471.208 -142.505)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2441",
    "data-name": "Group 2441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2440",
    "data-name": "Group 2440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2439",
    "data-name": "Group 2439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2438",
    "data-name": "Group 2438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2437",
    "data-name": "Group 2437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2436",
    "data-name": "Group 2436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M454.832,143.694a2.371,2.371,0,1,0,3.235-.871A2.383,2.383,0,0,0,454.832,143.694Z",
    transform: "translate(-454.514 -142.504)",
    fill: "#263238"
  })))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.abf0db40c8190364ef61ef3a0a748dcf.svg";
export { ForwardRef as ReactComponent };